/* Muslumana prayer mat live preview (prototype, design 801).
   - Mats drawn in real proportions (one cm-to-pixel scale for every size), with gray fringes on the
     top and bottom and a thin binding cord on the sides.
   - One name per person, placed inside its arch. Drag to move, pinch / wheel / +− to resize.
   - Positions are kept as fractions of the print image, so the same numbers place the name on the
     full-size print file.
*/
(function () {
  'use strict';

  /* ---------------- CONFIG (per design) ---------------- */
  const CFG = {
    design: '801',
    designName: 'Ottoman Floral',
    imgBase: 'designs/801/',
    // Designs in the picker. Each has designs/<code>/design.json (colors, arches per size, default name spot).
    designs: [{ code: '801', name: 'Ottoman Floral' }, { code: '612', name: 'Crystal Arch' }, { code: '613', name: 'Echo Arches' },
      { code: '608', name: 'Silk Damask' }, { code: '101', name: 'Royal Embossed' }, { code: '102', name: 'Gold Embroidered' }, { code: '409', name: 'Kids Moon & Stars' }, { code: '410', name: 'Kids Lamb & Stars' }, { code: '411', name: 'Kids Rainbow' }, { code: '416', name: 'Kids Spaceship' },
      { code: '417', name: 'Kids Kite' }, { code: '419', name: 'Kids Balloons' }, { code: '420', name: 'Kids Lantern' }, { code: '421', name: 'Kids Dome & Minaret' }, { code: '709', name: 'Couples Heart Set' },
      { code: '701', name: 'Golden Lattice Couples' }, { code: '702', name: 'Classic Filigree Couples' }, { code: '703', name: 'Twin Lattice Couples' }, { code: '704', name: 'Beaded Arch Couples' },
      { code: '705', name: 'Scroll Arch Couples' }, { code: '706', name: 'Emerald & Gold Couples' }, { code: '707', name: 'Silver & Gold Couples' }, { code: '708', name: 'Onyx & Pearl Couples' }],
    // Letter = the color code in the print file names (801A …), same order as the store's variants.
    // Colors and their default name color (the design's border color). designs/801/design.json overrides this
    // list when it loads, so the colors can be edited on GitHub without touching the code.
    colors: [
      { code: 'A', name: 'Cream', swatch: '#ede3cb', nameColor: '#4e4e4e' },
      { code: 'B', name: 'Yellow', swatch: '#f3dfa6', nameColor: '#8a7251' },
      { code: 'C', name: 'Maroon', swatch: '#61343c', nameColor: '#b0adb1' },
      { code: 'D', name: 'Blue', swatch: '#2e4878', nameColor: '#b0afb2' },
      { code: 'E', name: 'Sage Green', swatch: '#6f7c73', nameColor: '#aeacac' },
      { code: 'F', name: 'Gray', swatch: '#545251', nameColor: '#afadad' },
      { code: 'G', name: 'Brown', swatch: '#6a5348', nameColor: '#d5ba74' },
      { code: 'H', name: 'Dark Green', swatch: '#2e5045', nameColor: '#d7b976' },
      { code: 'I', name: 'Light Blue', swatch: '#7ebbbb', nameColor: '#d6b971' },
    ],
    // file: image name ending (801A-26x45.webp). cm: [width, height] with the arches pointing up. Arches measured from the images.
    sizes: [
      { key: 'L', file: '26x45', label: '26″×45″', sub: 'L · 1 person', inch: [26, 45], people: 1, cm: [66, 113],
        arches: [{ x0: 0.161, x1: 0.839, top: 0.1085, side: 0.286, bottom: 0.8915 }] },
      { key: 'XL', file: '32x52', label: '32″×52″', sub: 'XL · 1 person', inch: [32, 52], people: 1, cm: [80, 135],
        arches: [{ x0: 0.1603, x1: 0.8388, top: 0.1085, side: 0.286, bottom: 0.8915 }] },
      { key: '2P', file: '45x48', label: '45″×48″', sub: '2 people', inch: [48, 45], people: 2, cm: [120, 113],
        arches: [{ x0: 0.1144, x1: 0.4708, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.5292, x1: 0.8851, top: 0.1315, side: 0.2985, bottom: 0.8685 }] },
      { key: '3P', file: '45x71', label: '45″×71″', sub: '3 people', inch: [71, 45], people: 3, cm: [180, 113],
        arches: [{ x0: 0.0791, x1: 0.3321, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.3735, x1: 0.6265, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.6679, x1: 0.9209, top: 0.1315, side: 0.2985, bottom: 0.8685 }] },
      { key: '4P', file: '45x95', label: '45″×95″', sub: '4 people', inch: [95, 45], people: 4, cm: [240, 113],
        arches: [{ x0: 0.0671, x1: 0.2599, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.2914, x1: 0.4845, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.5158, x1: 0.7086, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.7401, x1: 0.9329, top: 0.1315, side: 0.2985, bottom: 0.8685 }] },
      { key: '5P', file: '45x118', label: '45″×118″', sub: '5 people', inch: [118, 45], people: 5, cm: [300, 113],
        arches: [{ x0: 0.0542, x1: 0.2121, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.2379, x1: 0.3957, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.4207, x1: 0.5785, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.6043, x1: 0.7621, top: 0.1315, side: 0.2985, bottom: 0.8685 },
                 { x0: 0.7879, x1: 0.9458, top: 0.1315, side: 0.2985, bottom: 0.8685 }] },
    ],
    fonts: [
      { n: 1, family: 'Alex Brush', scale: 1.15 },
      { n: 2, family: 'Nothing You Could Do', scale: 0.9 },
      { n: 3, family: 'Sacramento', scale: 1.2 },
      { n: 4, family: 'Dancing Script', scale: 1 },
      { n: 5, family: 'Playfair Display', scale: 0.85 },
      { n: 6, family: 'Crimson Pro', scale: 0.9 },
    ],
    // Name colors: 8 swatches. 1st is "Match border" (changes with the mat color and design), then Black, White and 5 main colors.
    inks: [
      { key: 'black', name: 'Black', hex: '#1d1d1f' },
      { key: 'white', name: 'White', hex: '#ffffff' },
      { key: 'silver', name: 'Silver', hex: '#b4b6ba' },
      { key: 'gold', name: 'Gold', hex: '#c9a24a' },
      { key: 'navy', name: 'Navy', hex: '#1f2f55' },
      { key: 'maroon', name: 'Maroon', hex: '#6d1f2b' },
      { key: 'green', name: 'Dark Green', hex: '#1f4d36' },
    ],
    // Default name spot for this design: direction, and where along the arch's straight part (0 = top, 1 = bottom).
    nameDefault: { vertical: false, along: 0.56, alongHorizontal: 0.86, sizeHorizontal: 0.15 }, // 801: most customers choose horizontal, bottom center
    maxSingle: 30,
    maxPerPerson: 20,
    minLetterCm: 4,       // smallest letter (font size) the workshop prints; names never get smaller (design.json minLetterCm can raise it)
    fringeCm: 2,          // fringe length (to confirm)
    textureCm: 30.4,      // one tile of the fabric texture (img/velvet.webp) covers this many cm
    texture: 0.6,         // how strongly the fabric texture shows (0 = off)
    fringeColor: [176, 177, 176],
    bindingCm: 0.9,       // side binding cord width (to confirm)
    floorCm: [330, 205],
    floorTileCm: [78, 170], // img/floor.webp: 4 laminate planks (~19.5 cm each) by 170 cm, drawn true to scale  // "real size" view: every size drawn on this floor at the same scale
  };

  /* ---------------- STATE ---------------- */
  const S = {
    color: 'A', size: 'L', font: 1, ink: 'match', // 'match' = the border color of the chosen mat color
    names: ['', '', '', '', ''],
    place: [], // per person: { dx, dy, scale, vertical } relative to the default spot
    sel: -1, view: 'real',
    linked: true, // family mats: all names move, resize and turn together, same letter size
  };
  // Theme mode: on the store's product page the snippet sets window.MM_LP (design code, file locations, the product).
  // The page's own color/size buttons, name fields and font buttons are used instead of the demo's controls.
  const HOST = window.MM_LP || null;
  if (HOST) { S.view = 'fit'; CFG.imgBase = HOST.filesBase; }
  let hostVariant = null; // store page: the variant shown now
  // how the customer makes the mat: 'self' = with the live preview, 'forme' = our team designs it and emails a proof
  let mode = null;
  try { mode = localStorage.getItem('mm-lp-mode'); } catch (_) { /* private mode */ }
  if (mode !== 'self' && mode !== 'forme') mode = null;
  // store page on a phone: taller preview, controls under it, wide mats show 2–3 places and swipe sideways
  const isPhone = () => !!HOST && window.matchMedia('(max-width: 749px)').matches;
  S.pan = 0; // px the wide mat is swiped to the left (phone, Zoom in)
  // the direction a name starts in; a design can lock it (design.json "horizontalOnly" or "verticalOnly": true)
  function startVertical() { return CFG.verticalOnly ? true : CFG.horizontalOnly ? false : !!CFG.nameDefault.vertical; }
  const resetPlace = () => { S.place = [0, 1, 2, 3, 4].map(() => ({ dx: 0, dy: 0, scale: 1, vertical: startVertical() })); };
  resetPlace();

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const setText = (sel, t) => { const e = $(sel); if (e) e.textContent = t; };
  const size = () => CFG.sizes.find((z) => z.key === S.size);
  const color = () => CFG.colors.find((c) => c.code === S.color);
  const font = () => CFG.fonts.find((f) => f.n === S.font);
  const fontLabel = (f = font()) => f.label || `Font ${f.n}`;
  const fontCss = (px) => `${font().weight || 400} ${px}px "${font().family}"`;
  // nameColor / bg can be one value or one per mat (couple sets: left, right)
  const perMat = (v, part) => (Array.isArray(v) ? v[part] || v[0] : v);
  // a plain color name for a hex, so "Match border" in the cart and emails says which color it is ("Match border · Gold")
  const HUES = [['Black', '#111111'], ['Charcoal', '#3a3a3a'], ['Gray', '#8a8a8a'], ['Silver', '#c4c4c4'], ['White', '#ffffff'], ['Cream', '#efe4cc'],
    ['Beige', '#cdb894'], ['Gold', '#c9a44c'], ['Mustard', '#d4a017'], ['Yellow', '#f2d43a'], ['Orange', '#e07b28'], ['Rust', '#a5482a'], ['Brown', '#6b4428'],
    ['Tan', '#b08a5c'], ['Red', '#c0262d'], ['Burgundy', '#6e1a2b'], ['Pink', '#e79ab0'], ['Blush', '#e8c3c0'], ['Rose', '#c2607a'], ['Purple', '#6b3f8f'],
    ['Lilac', '#b9a2d4'], ['Navy', '#1f2a44'], ['Blue', '#2f62b0'], ['Light Blue', '#9ccbe0'], ['Teal', '#21767a'], ['Turquoise', '#3cb8b0'],
    ['Green', '#2f7d3a'], ['Olive', '#6b6b2c'], ['Mint', '#a6dcc0'], ['Dark Green', '#1d4a33'], ['Sky Blue', '#1e9bd0'], ['Taupe', '#8b7670'],
    ['Sage', '#c3d8cc'], ['Bronze', '#7d5f1c']];
  const hueName = (h) => { // nearest by CIE Lab distance
    const lab = (x) => {
      const [r, g, b] = [1, 3, 5].map((o) => parseInt(x.slice(o, o + 2), 16) / 255).map((c) => (c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4));
      const f = (t) => (t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116);
      const X = f((0.4124 * r + 0.3576 * g + 0.1805 * b) / 0.9505), Y = f(0.2126 * r + 0.7152 * g + 0.0722 * b), Z = f((0.0193 * r + 0.1192 * g + 0.9505 * b) / 1.089);
      return [116 * Y - 16, 500 * (X - Y), 200 * (Y - Z)];
    };
    const a = lab(String(h).toLowerCase()); let best = HUES[0][0], d0 = Infinity;
    HUES.forEach(([n, x]) => { const c = lab(x), d = (a[0] - c[0]) ** 2 + (a[1] - c[1]) ** 2 + (a[2] - c[2]) ** 2; if (d < d0) { d0 = d; best = n; } });
    return best;
  };
  const ink = () => S.ink === 'match'
    ? { key: 'match', name: `Match border · ${[...new Set([].concat(color().nameColor).map(hueName))].join(' / ')} (${[].concat(color().nameColor).map((h) => h.toUpperCase()).join(' / ')})`, hex: perMat(color().nameColor, 0) }
    : (CFG.inks.find((i) => i.key === S.ink) || DEFAULT_INKS.find((i) => i.key === S.ink));
  // Readable name color for where the name sits: an area with its own background (612 field, 709 heart, kids mat)
  // never gets a name color that is hard to read on it; it switches to the area's own readable color.
  const lum = (h) => { const c = [1, 3, 5].map((o) => parseInt(h.slice(o, o + 2), 16) / 255).map((x) => (x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4)); return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]; };
  const contrast = (a, b) => { const x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); };
  function inkFor(b) {
    const part = b.a.part || 0, zone = b.zone || {}, bar = barStyle(b), own = bar ? bar.ink : zone.ink || perMat(color().nameColor, part);
    const bg = bar ? bar.fill : zone.bg || (color().bg && perMat(color().bg, part));
    const hex = S.ink === 'match' ? own : ink().hex;
    // (a color the customer picked with the Font buttons, 101/102, is always kept)
    return bg && !CFG.fontInks && contrast(hex, bg) < 2.5 ? { hex: own, swapped: true } : { hex, swapped: false };
  }
  const maxChars = () => (size().people > 1 ? CFG.maxPerPerson : CFG.maxSingle);
  // dragging a name: dashed lines through the middle of the mat (single mats) or of that person's place
  // (family mats: the mat split in equal places; couple sets: that mat); the name snaps to them
  const guideOf = (i) => {
    const z = size(), a = z.arches[i];
    const pt = z.parts ? z.parts[a.part || 0] : null, n = z.people;
    const x0 = pt ? pt.x0 : i / n, x1 = pt ? pt.x1 : (i + 1) / n;
    const y0 = pt && pt.y0 != null ? pt.y0 : 0, y1 = pt && pt.y1 != null ? pt.y1 : 1;
    return { x: (x0 + x1) / 2, y: (y0 + y1) / 2, box: { x0, x1, y0, y1 } };
  };
  const SNAP = 7; // px

  /* ---------------- IMAGES ---------------- */
  const cache = new Map();
  let lowPri = false;
  // a replaced picture keeps its file name, and browsers keep the old copy for a year: design.json "v" on a color
  // (or "imgV" for the whole design) changes the address, so everyone gets the new picture at once
  function ver(code, more) {
    const v = (CFG.colors.find((x) => x.code === code) || {}).v || CFG.imgV;
    return v ? `${more ? '&' : '?'}v=${encodeURIComponent(v)}` : '';
  }
  function img(code, key, side, noTile) { // side: couple sets have one image per mat (709-left-26x45.webp)
    const zk = CFG.sizes.find((z) => z.key === key);
    if (!zk) return new Image(); // a size of the previous design (the design was just switched)
    const d = CFG.design, c = side || code, f = zk.file;
    const src = `${d}-${c}-${f}`;
    // design.json "tile": "60x113" - family mats are made here from one picture per color (one person's area,
    // e.g. 413-A-60x113.webp) placed side by side; without that picture, the size's own file is used
    if (CFG.tile && !noTile && zk.people > 1 && !zk.parts && !side && !cache.has(src)) {
      const out = new Image(); out.decoding = 'async'; cache.set(src, out);
      const one = new Image(), tn = HOST ? [`${d}${c}-${CFG.tile}`, `${d}-${c}-${CFG.tile}`] : [`${d}-${c}-${CFG.tile}`];
      let t = 0;
      const q = (HOST ? `?width=${Math.round(2000 / zk.people)}` : '') + ver(code, HOST);
      out.onload = () => { schedule(); preloadColors(key, side); };
      one.onload = () => {
        const n = zk.people, tw = Math.min(one.naturalWidth, Math.round(2000 / n)), th = Math.round(one.naturalHeight * tw / one.naturalWidth);
        const c2 = document.createElement('canvas'); c2.width = tw * n; c2.height = th;
        const x2 = c2.getContext('2d'); for (let i = 0; i < n; i++) x2.drawImage(one, i * tw, 0, tw, th);
        c2.toBlob((b) => { if (b) out.src = URL.createObjectURL(b); else fallback(); }, 'image/webp', 0.9);
      };
      // no 60x113 picture for this color: forget this attempt and load the size's own file instead
      const fallback = () => { cache.delete(src); img(code, key, side, true); schedule(); };
      one.onerror = () => { if (++t < tn.length) one.src = `${CFG.imgBase}${tn[t]}.webp${q}`; else fallback(); };
      one.src = `${CFG.imgBase}${tn[0]}.webp${q}`;
      return out;
    }
    if (!cache.has(src)) {
      // the same file may be named 801A-26x45 (store Files), 801-A-26x45 (GitHub), 801-a-26x45 or 801a-26x45: try them in turn
      // kids mats are stored by color name instead of a letter: 409-Pink-20x36
      const cn = (CFG.colors.find((x) => x.code === c) || {}).name, byName = cn && !side ? [`${d}-${cn.replace(/\s+/g, '-')}-${f}`] : [];
      const names = HOST ? [`${d}${c}-${f}`, `${d}-${c}-${f}`, `${d}-${c.toLowerCase()}-${f}`, `${d}${c.toLowerCase()}-${f}`, ...byName]
        : [`${d}-${c}-${f}`, `${d}${c}-${f}`];
      // store: ask Shopify's CDN for a lighter copy (single mats 1200 px, wide family mats 2000 px) - loads several times faster
      const z0 = CFG.sizes.find((z) => z.key === key), q = (HOST ? `?width=${z0 && (z0.people > 1 || z0.parts) ? 2000 : 1200}` : '') + ver(code, HOST);
      const im = new Image(); im.decoding = 'async'; let k = 0;
      // the mat on screen first; the other colors wait behind it
      im.fetchPriority = lowPri ? 'low' : 'high';
      im.onload = () => { schedule(); preloadColors(key, side); };
      im.onerror = () => { if (++k < names.length) im.src = `${CFG.imgBase}${names[k]}.webp${q}`; else { im.dataset.failed = '1'; schedule(); } };
      im.src = `${CFG.imgBase}${names[0]}.webp${q}`; cache.set(src, im);
    }
    return cache.get(src);
  }
  // once a mat is shown, quietly load the other colors of that size, so changing color is instant
  const preloaded = new Set();
  function preloadColors(key, side) {
    const id = `${CFG.design}|${key}|${side || ''}`;
    if (preloaded.has(id) || (navigator.connection && navigator.connection.saveData)) return;
    preloaded.add(id);
    const later = window.requestIdleCallback || ((f) => setTimeout(f, 600));
    later(() => CFG.colors.forEach((c, i) => setTimeout(() => { lowPri = true; img(c.code, key, side); lowPri = false; }, i * 120)));
  }
  const lastShown = new Map(); // size → the last mat image drawn (kept on screen while a new color loads)
  let waiting = false;

  /* ---------------- CANVAS ---------------- */
  const cv = $('#mp-canvas'), ctx = cv.getContext('2d');
  // the theme's letter spacing must not reach the drawing (Safari takes it from the page): words fit their boxes
  cv.style.letterSpacing = '0px'; if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
  let W = 0, H = 0, dpr = 1;
  function resize() {
    dpr = Math.min(2, window.devicePixelRatio || 1);
    if (HOST && hostBox()) return; // store page: the same box as the product photos
    const box = cv.parentElement.getBoundingClientRect();
    W = box.width;
    // Real size: the fixed floor. Zoom in: the canvas takes the chosen mat's shape (tall for single mats).
    const [mw, mh] = size().cm, ratio = S.view === 'real' ? CFG.floorCm[1] / CFG.floorCm[0] : Math.min(1.3, Math.max(0.5, (mh + 2 * edgeCm() + 24) / (mw + 16)));
    H = Math.round(W * ratio);
    cv.style.height = H + 'px';
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    schedule();
  }
  // how far the fringe reaches past the mat (drawn fringe, or the real one in a photo-based image)
  const edgeCm = () => Math.max(CFG.drawFringe === false ? 0 : CFG.fringeCm, CFG.photoFringeCm || 0);
  let raf = 0;
  function schedule() { if (!raf) raf = requestAnimationFrame(() => { raf = 0; render(); }); }

  // Google fonts: the store loads their list without holding up the page (data-mm-fonts link);
  // the font on the mat is fetched first, the others once the page is idle, so changing font is still instant
  const fontList = new Promise((ok) => {
    const l = document.querySelector('link[data-mm-fonts="all"]');
    if (!l || l.media !== 'print') { ok(); return; }
    l.addEventListener('load', () => requestAnimationFrame(ok)); l.addEventListener('error', ok);
  });
  const fontAsked = new Set();
  function needFont(f) {
    if (!f || fontAsked.has(f.family)) return;
    fontAsked.add(f.family);
    fontList.then(() => document.fonts.load(`${f.weight || 400} 40px "${f.family}"`, 'Aisha'))
      .then(() => { if (f.family === font().family) { for (let i = 0; i < size().people; i++) clampScale(i); } schedule(); }, () => {});
  }
  function allFontsLater() {
    const later = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
    setTimeout(() => later(() => CFG.fonts.forEach(needFont)), 2500);
  }

  // a new size (store page, Zoom in):
  //  - more people (1 → 2…5, 3 → 4): show it at Real size for a moment, then slide back to Zoom in
  //  - fewer people on a mat still too wide to see at once (5 → 4, 4 → 3): show the whole new mat, then zoom in on the first places
  //  - fewer people down to 2 or a single, or single to single (L ↔ XL): a small zoom out and back in
  let tour = null;
  function sizeTour(from) {
    if (!HOST || S.view === 'real' || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    const a = CFG.sizes.find((z) => z.key === from), b = size();
    const kind = a && b.people > a.people ? 'real' : pannable() ? 'whole' : 'pulse';
    tour = { t0: performance.now(), kind }; schedule();
  }
  // 0 = Zoom in, 1 = the other end (Real size, the whole mat, or the small zoom out)
  // real: out 0.35 s, stay to 1.5 s, back in 0.6 s · whole: out 0.35 s, stay to 1.1 s, in 0.6 s · pulse: out 0.25 s, back by 0.75 s
  function tourAmount() {
    const t = performance.now() - tour.t0, ease = (x) => x * x * (3 - 2 * x);
    if (tour.kind === 'pulse') {
      if (t < 250) return ease(t / 250);
      if (t < 750) return 1 - ease((t - 250) / 500);
      return null;
    }
    const hold = tour.kind === 'whole' ? 1100 : 1500;
    if (t < 350) return ease(t / 350);
    if (t < hold) return 1;
    if (t < hold + 600) return 1 - ease((t - hold) / 600);
    return null;
  }
  function tourButtons(on) { $$('[data-view]:not([data-view="toggle"])').forEach((b) => b.setAttribute('aria-pressed', on ? b.dataset.view === 'real' : b.dataset.view === S.view)); }

  // Where the mat sits on the screen: px per cm and the mat rectangle.
  // phone, Zoom in: a family mat is shown about 2½ places wide (bigger names) and swiped sideways
  function phoneZoom(w, h) {
    const z = size(), [mw, mh] = z.cm, fr = edgeCm(), places = z.parts ? z.parts.length : z.people;
    const view = Math.min(mw, (mw / Math.max(1, places)) * 2.4);
    return Math.min((w - 24) / view, (h - 64) / (mh + 2 * fr));
  }
  // store page (phone and computer), Zoom in: a wide family mat shows 2–3 places and slides sideways
  // envelope icon for "Design it for me" (the ✉ character was too small to read)
  const MAIL = (px) => `<svg class="mp-mail" width="${px}" height="${px}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="m3.5 6.5 8.5 6.5 8.5-6.5"/></svg>`;
  const PEN = (px) => `<svg class="mp-mail" width="${px}" height="${px}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4z"/><path d="m13.5 6.5 4 4"/></svg>`;
  const PAN_L = 30; // room on the left for the height label
  // wide mats: a strip under the mat for See whole mat / Zoom in and the swipe note, side by side (never over the mat)
  const VIEW_ROW = 48;
  const viewRow = () => (HOST && wideMat() ? VIEW_ROW : 0);
  const RAIL = 76, SLIM = 40; // computer: room for the name tools column left of the preview (full / icons only)
  // a mat wider than the view when zoomed in (store: 3-5 people, on phones also 2): it slides sideways
  const wideMat = () => !!HOST && size().cm[0] * phoneZoom(W, H) > W - 24 + 0.5;
  const pannable = () => S.view === 'fit' && wideMat();
  function geom(w = W, h = H, mode = S.view) {
    const z = size(), [mw, mh] = z.cm, fr = edgeCm();
    if (w === W && h === H && mode !== 'real' && mode !== 'whole' && pannable()) { // 'whole': the full mat, no sliding
      const row = viewRow(), k = phoneZoom(w, h - row), max = mw * k - (w - PAN_L - 12);
      S.pan = Math.max(0, Math.min(max, S.pan));
      return { k, x: PAN_L - S.pan, y: (h - row - mh * k) / 2 + 6, w: mw * k, h: mh * k, pan: max };
    }
    let k;
    if (mode === 'real') k = Math.min(w / CFG.floorCm[0], h / CFG.floorCm[1]);
    else {
      // Zoom in keeps the sizes true to each other: all single mats share one scale (the biggest one fits),
      // so 32″×52″ really looks longer than 26″×45″
      const fitK = (q) => Math.min((w - 64) / q.cm[0], (h - 64) / (q.cm[1] + 2 * fr)); // room for the size labels
      const single = (q) => q.people === 1 && !q.parts;
      k = single(z) ? Math.min(...CFG.sizes.filter(single).map(fitK)) : fitK(z);
    }
    const row = w === W && h === H && mode !== 'real' ? viewRow() : 0; // keep the strip under a wide mat free
    if (row) k = Math.min(k, (h - row - 40) / (mh + 2 * fr));
    const x = (w - mw * k) / 2, y = (h - row - mh * k) / 2 + (row ? 6 : 0);
    return { k, x, y, w: mw * k, h: mh * k };
  }

  /* ---------------- NAME GEOMETRY ---------------- */
  // Everything in mat fractions (0..1). The text box is measured in cm and converted.
  const linked = () => S.linked && size().people > 1;
  function textW100(i) {
    const t = S.names[i].trim() || 'Name';
    if (font().balls) return ballsW(t, 100);
    ctx.save(); ctx.font = fontCss(100); const w = Math.max(1, ctx.measureText(t).width); ctx.restore();
    return w;
  }
  // Kids Font A: every letter on its own glossy colored ball (like the kids font chart)
  const BALLS = [['#ffc477', '#f7941d', '#c2620a'], ['#ff8a7a', '#e8412c', '#a8220f'], ['#c9f07f', '#7cc242', '#4a8a1c'],
    ['#e58fd0', '#b9449b', '#7d1f66'], ['#8fd8ff', '#27aae1', '#11709e'], ['#fff08a', '#f6c400', '#b88f00']];
  const ballsW = (t, em) => [...t].reduce((w, ch) => w + (ch === ' ' ? em * 0.45 : em), 0);
  function drawBalls(c, t, em, hex) {
    let x = -ballsW(t, em) / 2, k = 0;
    for (const ch of t) {
      if (ch === ' ') { x += em * 0.45; continue; }
      const r = em * 0.48, cx = x + em / 2, [lt, mid, dk] = BALLS[k++ % BALLS.length];
      const gr = c.createRadialGradient(cx - r * 0.35, -r * 0.4, r * 0.1, cx, 0, r);
      gr.addColorStop(0, lt); gr.addColorStop(0.55, mid); gr.addColorStop(1, dk);
      c.save(); c.shadowColor = 'rgba(0,0,0,.25)'; c.shadowBlur = em * 0.06; c.shadowOffsetY = em * 0.03;
      c.fillStyle = gr; c.beginPath(); c.arc(cx, 0, r, 0, Math.PI * 2); c.fill(); c.restore();
      c.fillStyle = 'rgba(255,255,255,.45)'; c.beginPath(); c.ellipse(cx - r * 0.25, -r * 0.55, r * 0.38, r * 0.17, -0.3, 0, Math.PI * 2); c.fill();
      c.save(); c.font = `${font().weight || 700} ${em * 0.64}px "${font().family}"`; c.fillStyle = hex;
      c.shadowColor = 'rgba(0,0,0,.35)'; c.shadowBlur = em * 0.04; c.shadowOffsetY = em * 0.02;
      // center the letter's own shape in the ball (not the font's line box)
      c.textAlign = 'center'; c.textBaseline = 'alphabetic';
      const m = c.measureText(ch);
      c.fillText(ch, cx + (m.actualBoundingBoxLeft - m.actualBoundingBoxRight) / 2, (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2); c.restore();
      x += em;
    }
  }
  // default letter size (cm) before the customer's resize: fits the arch across and along
  // The box a name is sized and placed by: its arch, or for a vertical name when the arch area takes only
  // horizontal names (408/605: the band above the window), the first vertical-only area (the strip beside it).
  function homeOf(i) {
    const z = size(), a = z.arches[i];
    if (!(a.horizontalOnly && S.place[i].vertical)) return a;
    const zs = (z.zones && z.zones[i]) || [], r = zs.find((q) => q.verticalOnly) || zs.find((q) => !q.horizontalOnly); // 701/703: the heart
    return r ? { x0: r.x0, x1: r.x1, side: r.y0, bottom: r.y1 } : a;
  }
  function baseEm(i) {
    const z = size(), a = homeOf(i), P = S.place[i], [mw, mh] = z.cm, f = font();
    const archW = (a.x1 - a.x0) * mw, archLen = (a.bottom - a.side) * mh;
    const along = P.vertical ? archLen * 0.62 : archW * 0.8;
    const nd = CFG.nameDefault, across = P.vertical ? (nd.sizeVertical || 0.3) : (nd.sizeHorizontal || 0.22); // letter size as a share of the arch width
    return Math.max(2.5, Math.min(archW * across * f.scale, (along * 100) / textW100(i)));
  }
  // Where name i may go: its arch (straight part + a little into the dome), plus the design's extra
  // areas for that person (design.json "zones"; some, like 612 above/below the arch, only for horizontal names,
  // some, like the 408/605 strips beside the window, only for vertical names).
  function zonesFor(i) {
    const z = size(), a = z.arches[i], P = S.place[i], pad = (a.x1 - a.x0) * 0.04;
    // an arch can give its exact shape (709: the arch without the half heart), else a box inside the arch
    const list = a.horizontalOnly && P.vertical ? [] : a.area ? [a.area] : [{ x0: a.x0 + pad, x1: a.x1 - pad, y0: a.side - 0.04, y1: a.bottom - 0.012 }];
    ((z.zones && z.zones[i]) || []).forEach((r) => { if (!(r.horizontalOnly && P.vertical) && !(r.verticalOnly && !P.vertical)) list.push(r); });
    return list.length ? list : [{ x0: a.x0 + pad, x1: a.x1 - pad, y0: a.side - 0.04, y1: a.bottom - 0.012 }];
  }
  // Where a name box (bw × bh) can sit inside an area, as close as possible to (wx, wy); null if it doesn't fit.
  // An area is a box (x0..x1, y0..y1) or an exact shape: spans = rows [y, left x, right x] at an even step.
  function fitZone(r, bw, bh, wx, wy, mw, mh) {
    if (!r.spans) {
      if (bw > r.x1 - r.x0 + 1e-9 || bh > r.y1 - r.y0 + 1e-9) return null;
      const x = Math.min(Math.max(wx, r.x0 + bw / 2), r.x1 - bw / 2), y = Math.min(Math.max(wy, r.y0 + bh / 2), r.y1 - bh / 2);
      return { x, y, d: Math.hypot((x - wx) * mw, (y - wy) * mh) };
    }
    const S = r.spans, n = S.length, step = (S[n - 1][0] - S[0][0]) / (n - 1), a = Math.ceil(bh / 2 / step - 1e-9), win = 2 * a + 1;
    if (n < 2 || win > n) return null;
    // over every run of rows the box would cover: the rightmost left edge and the leftmost right edge
    const ext = (k, isMax) => {
      const out = new Float64Array(n), dq = new Int32Array(n); let h = 0, t = 0;
      for (let q = 0; q < n; q++) {
        const v = S[q][k];
        while (t > h && (isMax ? S[dq[t - 1]][k] <= v : S[dq[t - 1]][k] >= v)) t--;
        dq[t++] = q; if (dq[h] <= q - win) h++;
        if (q >= win - 1) out[q - a] = S[dq[h]][k];
      }
      return out;
    };
    const L = ext(1, true), R = ext(2, false);
    let best = null;
    for (let c = a; c < n - a; c++) {
      const lo = L[c] + bw / 2, hi = R[c] - bw / 2; if (lo > hi) continue;
      const x = Math.min(Math.max(wx, lo), hi), y = S[c][0], d = Math.hypot((x - wx) * mw, (y - wy) * mh);
      if (!best || d < best.d) best = { x, y, d };
    }
    return best;
  }
  // letter size (cm) before fitting into an area: default size × the customer's resize;
  // together: every name gets the letter size of the longest name, so all names match
  function emOf(i) {
    const z = size(); let em = baseEm(i);
    if (linked()) for (let j = 0; j < z.people; j++) if (S.names[j].trim()) em = Math.min(em, baseEm(j));
    return em * S.place[i].scale;
  }
  function nameBox(i, g) {
    const z = size(), a = z.arches[i], P = S.place[i], [mw, mh] = z.cm;
    const text = S.names[i].trim();
    const w100 = textW100(i);
    let em = emOf(i);
    const minF = Math.min(1, CFG.minLetterCm / em); // an area that needs the name smaller than the smallest letter (4 cm) is not offered
    // rotated box size in mat fractions
    const box = (e) => { const tw = (w100 * e) / 100, th = e * 1.05; return { tw, th, bw: (P.vertical ? th : tw) / mw, bh: (P.vertical ? tw : th) / mh }; };
    const b0 = box(em);
    const h = homeOf(i), cx0 = (h.x0 + h.x1) / 2, cy0 = h.side + (h.bottom - h.side) * (P.vertical ? CFG.nameDefault.along : CFG.nameDefault.alongHorizontal);
    const wx = cx0 + P.dx, wy = cy0 + P.dy;
    // the allowed area closest to where the customer wants the name; a name too big for that area shrinks to fit it
    let best = null;
    zonesFor(i).forEach((r) => {
      let f = 1, hit = fitZone(r, b0.bw, b0.bh, wx, wy, mw, mh);
      if (!hit) { // too big for this area: the largest size that fits (not below the smallest letter)
        let lo = minF, hi = 1;
        hit = fitZone(r, b0.bw * lo, b0.bh * lo, wx, wy, mw, mh);
        if (!hit) return;
        for (let k = 0; k < 12; k++) { const m = (lo + hi) / 2, h2 = fitZone(r, b0.bw * m, b0.bh * m, wx, wy, mw, mh); if (h2) { lo = m; hit = h2; } else hi = m; }
        f = lo;
      }
      const { x, y, d } = hit;
      if (!best || d < best.d - 1e-6 || (d <= best.d + 1e-6 && f > best.f)) best = { r, f, x, y, d }; // equal: the area where it stays biggest
    });
    if (!best) best = { r: zonesFor(i)[0], f: minF, x: wx, y: wy, d: 0 };
    em *= best.f;
    const { tw, th, bw, bh } = box(em);
    return { text, em, emPx: em * (g ? g.k : 1), tw, th, bw, bh, cx: best.x, cy: best.y, cx0, cy0, a, zone: best.r, fits: best.f > 0.999, vertical: !!P.vertical };
  }
  // keep scale within the arch: shrink until it fits
  function clampScale(i) {
    const P = S.place[i], all = linked() ? [...Array(size().people).keys()] : [i];
    if (linked()) all.forEach((j) => { S.place[j].scale = P.scale; S.place[j].vertical = P.vertical; });
    for (let n = 0; n < 30; n++) {
      if (all.every((j) => nameBox(j).fits)) break;
      all.forEach((j) => { S.place[j].scale *= 0.95; });
    }
    all.forEach((j) => { S.place[j].scale = Math.min(1.8, Math.max(0.4, S.place[j].scale)); });
    // never below the smallest letter size
    all.forEach((j) => { const e = emOf(j); if (e < CFG.minLetterCm) S.place[j].scale *= CFG.minLetterCm / e; });
    settle(i);
  }
  // Keep names inside their arch. Together: every name gets the same offset, the one that fits them all.
  function settle(i) {
    const P = S.place[i];
    if (!linked()) { const b = nameBox(i); P.dx = b.cx - b.cx0; P.dy = b.cy - b.cy0; return; }
    // together + one name inside a named area (709 heart): every name goes into its own area of that kind, same spot in it
    const b = nameBox(i), z = size();
    if (b.zone.area) {
      const k = zonesFor(i).filter((r) => r.area === b.zone.area).indexOf(b.zone);
      const u = (b.cx - b.zone.x0) / (b.zone.x1 - b.zone.x0 || 1), v = (b.cy - b.zone.y0) / (b.zone.y1 - b.zone.y0 || 1);
      P.dx = b.cx - b.cx0; P.dy = b.cy - b.cy0;
      const place = () => { for (let j = 0; j < size().people; j++) {
        if (j === i) continue;
        const Q = S.place[j]; Q.scale = P.scale; Q.vertical = P.vertical;
        const list = zonesFor(j).filter((r) => r.area === b.zone.area), r = list[k] || list[0];
        if (!r) continue;
        const bj = nameBox(j);
        // mirror areas (709 hearts: two halves of one heart): the other name is the mirror image across the seam
        // between the mats, so moving one right moves the other left; up and down stay together
        const pi = z.parts && z.parts[b.a.part || 0], pj = z.parts && z.parts[bj.a.part || 0];
        if (r.mirror && pi && pj && pi !== pj) {
          const seam = pi.x0 < pj.x0 ? (pi.x1 + pj.x0) / 2 : (pj.x1 + pi.x0) / 2;
          Q.dx = 2 * seam - b.cx - bj.cx0; Q.dy = b.cy - bj.cy0;
        } else { Q.dx = r.x0 + u * (r.x1 - r.x0) - bj.cx0; Q.dy = r.y0 + v * (r.y1 - r.y0) - bj.cy0; }
      } };
      // same letter size in every heart: shrink together until all names fit their heart
      place();
      for (let n = 0; n < 30 && ![...Array(size().people).keys()].every((j) => !S.names[j].trim() || nameBox(j).fits); n++) { P.scale *= 0.95; place(); }
      return;
    }
    // couple sets: the other name takes the same spot on its own mat (same share of the mat's width and height),
    // so both move the same way; only inside the heart do they mirror (above)
    if (z.parts) {
      const pi = z.parts[b.a.part || 0], u = (b.cx - pi.x0) / (pi.x1 - pi.x0), v = (b.cy - pi.y0) / (pi.y1 - pi.y0);
      P.dx = b.cx - b.cx0; P.dy = b.cy - b.cy0;
      for (let j = 0; j < z.people; j++) {
        if (j === i) continue;
        const Q = S.place[j]; Q.scale = P.scale; Q.vertical = P.vertical;
        const bj = nameBox(j), pj = z.parts[bj.a.part || 0];
        Q.dx = pj.x0 + u * (pj.x1 - pj.x0) - bj.cx0; Q.dy = pj.y0 + v * (pj.y1 - pj.y0) - bj.cy0;
      }
      return;
    }
    const want = { dx: P.dx, dy: P.dy };
    let dx = want.dx, dy = want.dy;
    for (let j = 0; j < z.people; j++) {
      const Q = S.place[j]; Q.scale = P.scale; Q.vertical = P.vertical; Q.dx = want.dx; Q.dy = want.dy;
      const b = nameBox(j), cdx = b.cx - b.cx0, cdy = b.cy - b.cy0;
      if (Math.abs(cdx) < Math.abs(dx)) dx = cdx;
      if (Math.abs(cdy) < Math.abs(dy)) dy = cdy;
    }
    for (let j = 0; j < z.people; j++) { S.place[j].dx = dx; S.place[j].dy = dy; }
  }

  /* ---------------- DRAWING ---------------- */
  // Real fringe photo (img/fringe.webp): seamless strip, woven band on top, strands hanging down.
  // The strip is tiled across the mat width; for the top edge it is flipped.
  const fringeImg = new Image(); fringeImg.src = HOST ? HOST.fringeUrl : 'img/fringe.webp'; fringeImg.onload = () => schedule();
  // wood floor behind the mat (store: theme asset mp-floor.webp next to mp-fringe.webp)
  const floorImg = new Image(); floorImg.src = HOST ? (HOST.floorUrl || HOST.fringeUrl.replace('mp-fringe.webp', 'mp-floor.webp')) : 'img/floor.webp';
  floorImg.onload = () => schedule();
  // the mat fabric (velvet pile) laid over the printed design; ?texture=0 in the address turns it off to compare
  const velvetImg = new Image(); velvetImg.onload = () => schedule();
  if (!/[?&]texture=0/.test(location.search)) velvetImg.src = HOST ? (HOST.velvetUrl || HOST.fringeUrl.replace('mp-fringe.webp', 'mp-velvet.webp')) : 'img/velvet.webp';
  function drawTexture(c, x, y, w, h, k) {
    if (!CFG.textureOn || !(CFG.texture > 0) || !velvetImg.complete || !velvetImg.naturalWidth) return;
    const pat = c.createPattern(velvetImg, 'repeat'); if (!pat || !pat.setTransform) return;
    const sc = (CFG.textureCm * k) / velvetImg.naturalWidth;
    pat.setTransform(new DOMMatrix([sc, 0, 0, sc, x, y]));
    // soft light: mid-gray changes nothing, lighter and darker pile lift and shade the colors underneath
    c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip();
    c.globalCompositeOperation = 'soft-light'; c.globalAlpha = CFG.texture; c.fillStyle = pat; c.fillRect(x, y, w, h);
    c.restore();
  }
  // store: if the theme asset is missing, use mp-floor.webp from Content → Files (like the mat images)
  floorImg.onerror = () => { if (HOST && !floorImg.dataset.tried) { floorImg.dataset.tried = '1'; floorImg.src = `${HOST.filesBase}mp-floor.webp`; } };
  // the floor at true scale (planks move with the mat), softer in Zoom in so the mat and names stay brightest
  function drawFloor(c, w, h, g, real) {
    if (!floorImg.complete || !floorImg.naturalWidth) {
      const bg = c.createLinearGradient(0, 0, 0, h); bg.addColorStop(0, '#f1eee9'); bg.addColorStop(1, '#e6e1d9');
      c.fillStyle = bg; c.fillRect(0, 0, w, h); return;
    }
    const sc = (CFG.floorTileCm[0] * g.k) / floorImg.naturalWidth, pat = c.createPattern(floorImg, 'repeat');
    if (pat.setTransform) pat.setTransform(new DOMMatrix([sc, 0, 0, sc, g.x, g.y]));
    c.fillStyle = pat; c.fillRect(0, 0, w, h);
    c.fillStyle = real ? 'rgba(244,241,236,.22)' : 'rgba(240,237,232,.5)'; c.fillRect(0, 0, w, h);
  }
  function drawFringe(c, x, y, w, len, dir, k) {
    if (fringeImg.complete && fringeImg.naturalWidth) {
      const h = len / 0.82, tw = h * fringeImg.naturalWidth / fringeImg.naturalHeight, overlap = 0.25 * k;
      c.save(); c.beginPath(); c.rect(x, dir < 0 ? y - h : y - overlap, w, h + overlap); c.clip();
      c.translate(0, dir < 0 ? y + overlap : y - overlap); if (dir < 0) c.scale(1, -1);
      for (let px = x; px < x + w; px += tw) c.drawImage(fringeImg, px, 0, tw, h);
      c.restore(); return;
    }
    // dir: -1 = up (top edge), 1 = down (bottom edge)
    const [r, gg, b] = CFG.fringeColor, step = Math.max(1.2, 0.33 * k);
    // knotted header band
    const band = 0.7 * k;
    c.fillStyle = `rgb(${r - 25},${gg - 25},${b - 25})`;
    c.fillRect(x, dir < 0 ? y - band : y, w, band);
    let seed = 7;
    const rnd = () => ((seed = (seed * 16807) % 2147483647) / 2147483647);
    c.lineCap = 'round';
    for (let px = x + step / 2; px < x + w; px += step) {
      const L = len * (0.86 + rnd() * 0.2), sway = (rnd() - 0.5) * 0.25 * k, shade = Math.round((rnd() - 0.5) * 34);
      c.strokeStyle = `rgb(${r + shade},${gg + shade},${b + shade})`;
      c.lineWidth = Math.max(0.6, step * 0.62);
      const y0 = dir < 0 ? y - band : y + band, y1 = y0 + dir * L;
      c.beginPath(); c.moveTo(px, y0);
      c.quadraticCurveTo(px + sway, (y0 + y1) / 2, px + sway * 1.6, y1); c.stroke();
    }
  }
  function drawBinding(c, x, y, h, k) {
    const bw = Math.max(1.5, CFG.bindingCm * k);
    const grd = c.createLinearGradient(x - bw / 2, 0, x + bw / 2, 0);
    grd.addColorStop(0, '#8e8f8f'); grd.addColorStop(0.5, '#c4c5c4'); grd.addColorStop(1, '#8e8f8f');
    c.fillStyle = grd;
    c.beginPath(); c.roundRect ? c.roundRect(x - bw / 2, y, bw, h, bw / 2) : c.rect(x - bw / 2, y, bw, h); c.fill();
  }
  // The mat's background color, read from the image itself (the most common color, leaving out the light frame and pattern lines).
  const groundCache = new Map();
  function groundOf(im) {
    if (!im || !im.complete || !im.naturalWidth) return null;
    if (groundCache.has(im.src)) return groundCache.get(im.src);
    const w = 160, h = Math.max(1, Math.round(160 * im.naturalHeight / im.naturalWidth)), cv2 = document.createElement('canvas');
    cv2.width = w; cv2.height = h; const x = cv2.getContext('2d'); x.drawImage(im, 0, 0, w, h);
    const d = x.getImageData(0, 0, w, h).data, cnt = new Map();
    for (let i = 0; i < d.length; i += 4) { if (d[i] * 0.3 + d[i + 1] * 0.59 + d[i + 2] * 0.11 > 222) continue; const q = ((d[i] >> 3) << 10) | ((d[i + 1] >> 3) << 5) | (d[i + 2] >> 3); cnt.set(q, (cnt.get(q) || 0) + 1); }
    let bq = -1, bn = 0; for (const [q, n] of cnt) if (n > bn) { bn = n; bq = q; }
    if (bq < 0) return null;
    const m = [(bq >> 10) << 3, ((bq >> 5) & 31) << 3, (bq & 31) << 3]; let r = 0, gg = 0, bb = 0, n = 0;
    for (let i = 0; i < d.length; i += 4) if (Math.abs(d[i] - m[0] - 4) + Math.abs(d[i + 1] - m[1] - 4) + Math.abs(d[i + 2] - m[2] - 4) < 24) { r += d[i]; gg += d[i + 1]; bb += d[i + 2]; n++; }
    const hex = '#' + [r, gg, bb].map((v) => Math.round(v / n).toString(16).padStart(2, '0')).join('');
    groundCache.set(im.src, hex); return hex;
  }
  // patch around the name (px on this canvas): a little bigger than the text, soft edges, never more than ~1 cm past it
  function patchBox(b, g) {
    const padX = Math.min(b.emPx * 0.35, g.k * 1.0), padY = Math.min(b.emPx * 0.12, g.k * 0.5);
    const vert = b.vertical; // the name's own direction (a 1–2 letter name is taller than wide, but still horizontal)
    const w = b.bw * g.w + 2 * (vert ? padY : padX), h = b.bh * g.h + 2 * (vert ? padX : padY);
    return { w, h, vert, r: Math.min(w, h) / 2, blur: Math.min(padX, padY) * 1.6 };
  }
  // nameStyle.patch "bar" (701, 703, 704): a solid band from frame to frame behind a name in the arch (not in the heart),
  // with two border lines along it. fill / line / ink: one value or one per mat; line and ink default to the frame color.
  function barStyle(b) {
    if (CFG.patch !== 'bar' || !b.a || !b.a.area || b.zone !== b.a.area) return null;
    const part = b.a.part || 0, bs = CFG.nameStyle.bar || {};
    return { fill: perMat(bs.fill || color().bg, part), line: perMat(bs.line || color().nameColor, part), ink: perMat(bs.ink || color().nameColor, part),
      lines: bs.lines || [[0.15, 0.3], [0.6, 0.1]] }; // border lines: [cm in from the bar's edge, line width cm]
  }
  // the bar's thickness across the name (px on this canvas; g.k = px per cm): the text plus room above and below
  const barThick = (b, g) => {
    const [pe, pc] = (CFG.nameStyle && CFG.nameStyle.bar && CFG.nameStyle.bar.pad) || [0.45, 1.4]; // room above and below: share of the letter size, at least pc cm
    return (b.vertical ? b.bw * g.w : b.bh * g.h) + 2 * Math.max(b.emPx * pe, g.k * pc);
  };
  function drawBar(c, g, b, st, px, py) {
    // reach: cm further out than the name area's edge, so the bar meets the frame (patterned arches measured with a wider margin)
    const z = size(), rc = (CFG.nameStyle.bar && CFG.nameStyle.bar.reachCm) || 0, ex = rc / z.cm[0], ey = rc / z.cm[1];
    // a measured frame edge (arches[].edge: the inside of the frame, row by row) lets the bar touch the frame exactly
    const ov = 0.08 / z.cm[0], edge = b.a.edge ? b.a.edge.map(([y, l, r]) => [y, l - ov, r + ov])
      : archEdge(b.a.area).map(([y, l, r], i, A) => [y + (i === 0 ? -ey : i === A.length - 1 ? ey : 0), l - ex, r + ex]), t = barThick(b, g), k = g.k, v = b.vertical;
    c.save(); c.beginPath();
    edge.forEach((r, i) => (i ? c.lineTo(g.x + r[1] * g.w, g.y + r[0] * g.h) : c.moveTo(g.x + r[1] * g.w, g.y + r[0] * g.h)));
    for (let i = edge.length - 1; i >= 0; i--) c.lineTo(g.x + edge[i][2] * g.w, g.y + edge[i][0] * g.h);
    c.closePath(); c.clip();
    c.fillStyle = st.fill;
    if (v) c.fillRect(px - t / 2, g.y, t, g.h); else c.fillRect(g.x, py - t / 2, g.w, t);
    c.strokeStyle = st.line;
    // border lines along both edges (default: a 0.3 cm line at the edge and a 0.1 cm line 0.6 cm inside it)
    st.lines.forEach(([off, lw]) => {
      c.lineWidth = lw * k; c.beginPath();
      for (const s of [-1, 1]) {
        const o = s * (t / 2 - off * k);
        if (v) { c.moveTo(px + o, g.y); c.lineTo(px + o, g.y + g.h); } else { c.moveTo(g.x, py + o); c.lineTo(g.x + g.w, py + o); }
      }
      c.stroke();
    });
    c.restore();
  }
  // The inside of the arch up to the frame: the name area's shape grown back by the margin it was kept off the frame.
  function archEdge(area) {
    const z = size(), [mxc, myc] = (CFG.nameStyle && CFG.nameStyle.spanMarginCm) || [1.2, 1], mx = mxc / z.cm[0], my = myc / z.cm[1], sp = area.spans;
    return [[sp[0][0] - my, sp[0][1] - mx, sp[0][2] + mx], ...sp.map(([y, l, r]) => [y, l - mx, r + mx]), [sp[sp.length - 1][0] + my, sp[sp.length - 1][1] - mx, sp[sp.length - 1][2] + mx]];
  }
  // filled shape with feathered edges in every browser: draw it far away and keep only its blurred shadow
  function softPatch(c, x, y, w, h, r, blur, color) {
    const t = c.getTransform(), s = Math.hypot(t.a, t.b) || 1, OFF = 100000;
    c.save(); c.shadowColor = color; c.shadowBlur = blur * s; c.shadowOffsetX = OFF * s; c.shadowOffsetY = 0; c.fillStyle = '#000';
    c.beginPath(); c.roundRect ? c.roundRect(x - OFF, y, w, h, r) : c.rect(x - OFF, y, w, h); c.fill(); c.restore();
  }
  function drawMat(c, g, opts = {}) {
    const z = size();
    const fr = CFG.fringeCm * g.k;
    // one mat, or a set of mats side by side (couple set: left + right image)
    (z.parts || [{ x0: 0, x1: 1 }]).forEach((pt, k) => {
      const im = img(S.color, z.key, pt.side), x = g.x + pt.x0 * g.w, w = (pt.x1 - pt.x0) * g.w;
      const y = g.y + (pt.y0 || 0) * g.h, h = ((pt.y1 == null ? 1 : pt.y1) - (pt.y0 || 0)) * g.h;
      c.save(); c.shadowColor = 'rgba(0,0,0,.22)'; c.shadowBlur = 14 * (opts.scale || 1); c.shadowOffsetY = 5 * (opts.scale || 1);
      c.fillStyle = perMat(color().fill || color().bg, k) || color().swatch; c.fillRect(x, y, w, h); c.restore(); // fill: the mat color while its picture loads (kids: bg is only the name area)
      // photo-based mats (102) can include their real fringe: the image reaches that far past the body at top and bottom
      const ext = (CFG.photoFringeCm || 0) * g.k;
      const sk = `${z.key}|${pt.side || ''}`;
      if (im.complete && im.naturalWidth) { c.drawImage(im, x, y - ext, w, h + 2 * ext); drawTexture(c, x, y, w, h, g.k); if (opts.ui) lastShown.set(sk, im); }
      else if (opts.ui && !im.dataset.failed) { // still loading: the previous color of this size, faded, and the spinner
        waiting = true;
        const prev = lastShown.get(sk);
        if (prev) { c.save(); c.globalAlpha = 0.55; c.drawImage(prev, x, y - ext, w, h + 2 * ext); c.restore(); }
      }
      if (CFG.drawFringe !== false) { drawFringe(c, x, y, w, fr, -1, g.k); drawFringe(c, x, y + h, w, fr, 1, g.k); }
      if (CFG.drawBinding !== false) { drawBinding(c, x, y, h, g.k); drawBinding(c, x + w, y, h, g.k); }
    });
    // middle lines of the place while a name is dragged (gold and solid when the name sits on one)
    if (opts.ui && gesture && gesture.mode === 'move' && gesture.moved && gesture.i < z.people) {
      const gd = guideOf(gesture.i), a = gd.box, X = (v) => g.x + v * g.w, Y = (v) => g.y + v * g.h;
      const line = (on, x0, y0, x1, y1) => {
        c.save(); c.lineWidth = on ? 1.5 : 1; c.setLineDash(on ? [] : [6, 5]);
        c.strokeStyle = on ? 'rgba(214,160,20,1)' : 'rgba(46,46,45,.7)'; c.shadowColor = 'rgba(255,255,255,.9)'; c.shadowBlur = 3;
        c.beginPath(); c.moveTo(x0, y0); c.lineTo(x1, y1); c.stroke(); c.restore();
      };
      line(gesture.snapX, X(gd.x), Y(a.y0), X(gd.x), Y(a.y1));
      line(gesture.snapY, X(a.x0), Y(gd.y), X(a.x1), Y(gd.y));
    }
    // allowed name areas: outlined while a name is selected, lit up while it is dragged
    if (opts.ui && S.sel >= 0 && S.sel < z.people) {
      const drag = gesture && gesture.mode === 'move';
      c.save(); c.lineWidth = drag ? 1.5 : 1; c.setLineDash(drag ? [] : [4, 4]);
      c.strokeStyle = drag ? 'rgba(243,188,39,.95)' : 'rgba(243,188,39,.6)'; c.fillStyle = 'rgba(243,188,39,.2)';
      c.beginPath();
      const X = (v) => g.x + v * g.w, Y = (v) => g.y + v * g.h;
      (linked() ? [...Array(z.people).keys()] : [S.sel]).forEach((j) => zonesFor(j).forEach((r) => {
        if (!r.spans) { c.rect(X(r.x0), Y(r.y0), (r.x1 - r.x0) * g.w, (r.y1 - r.y0) * g.h); return; }
        const sp = r.spans; c.moveTo(X(sp[0][1]), Y(sp[0][0]));
        sp.forEach((q) => c.lineTo(X(q[1]), Y(q[0]))); for (let k = sp.length - 1; k >= 0; k--) c.lineTo(X(sp[k][2]), Y(sp[k][0]));
        c.closePath();
      }));
      if (drag) c.fill(); c.stroke();
      c.restore();
    }
    // names
    for (let i = 0; i < z.people; i++) {
      const b = nameBox(i, g);
      if (!b.text) { if (opts.ui) drawPlaceholder(c, b, g, i); continue; }
      const px = g.x + b.cx * g.w, py = g.y + b.cy * g.h;
      // patterned designs (608): a soft clear patch in the mat's background color hides the pattern behind the name
      const pt = (z.parts || [{}])[b.a.part || 0], bar = barStyle(b), ground = CFG.patch && CFG.patch !== 'bar' && groundOf(img(S.color, z.key, pt.side));
      if (bar) drawBar(c, g, b, bar, px, py);
      else if (ground) {
        const q = patchBox(b, g), edge = CFG.patch === 'strip' && b.a.area && b.zone === b.a.area ? archEdge(b.a.area) : null;
        if (edge) { // strip: runs to the arch frame on both sides of the name (along the name's direction)
          c.save(); c.beginPath();
          edge.forEach((r, k) => (k ? c.lineTo(g.x + r[1] * g.w, g.y + r[0] * g.h) : c.moveTo(g.x + r[1] * g.w, g.y + r[0] * g.h)));
          for (let k = edge.length - 1; k >= 0; k--) c.lineTo(g.x + edge[k][2] * g.w, g.y + edge[k][0] * g.h);
          c.closePath(); c.clip();
          if (q.vert) softPatch(c, px - q.w / 2, g.y - q.blur * 2, q.w, g.h + q.blur * 4, 0, q.blur, ground);
          else softPatch(c, g.x - q.blur * 2, py - q.h / 2, g.w + q.blur * 4, q.h, 0, q.blur, ground);
          c.restore();
        } else softPatch(c, px - q.w / 2, py - q.h / 2, q.w, q.h, q.r, q.blur, ground);
      }
      c.save(); c.translate(px, py); if (S.place[i].vertical) c.rotate(-Math.PI / 2);
      c.font = fontCss(b.emPx); c.textAlign = 'center'; c.textBaseline = 'middle';
      const hex = inkFor(b).hex;
      if (font().balls) drawBalls(c, b.text, b.emPx, hex);
      else {
        c.fillStyle = hex;
        // kids designs: a soft shadow keeps white names readable on the light mats
        if (CFG.nameStyle && CFG.nameStyle.blend === 'print') {
          // printed into the velvet: the fabric texture and embossing show through the ink
          c.globalCompositeOperation = 'multiply'; c.fillText(b.text, 0, b.emPx * 0.06);
          c.globalCompositeOperation = 'source-over'; c.globalAlpha = 0.55; c.fillText(b.text, 0, b.emPx * 0.06);
        } else {
          if (CFG.textShadow) { c.shadowColor = 'rgba(0,0,0,.4)'; c.shadowBlur = b.emPx * 0.06; c.shadowOffsetY = b.emPx * 0.03; }
          else { c.shadowColor = 'rgba(0,0,0,.18)'; c.shadowBlur = 0.6; c.shadowOffsetY = 0.4; }
          c.fillText(b.text, 0, b.emPx * 0.06);
        }
      }
      c.restore();
      if (opts.ui && (S.sel === i || (S.sel >= 0 && linked()))) {
        const bw = b.bw * g.w, bh = b.bh * g.h;
        c.save(); c.setLineDash([5, 4]); c.strokeStyle = '#f3bc27'; c.lineWidth = 1.5;
        c.strokeRect(px - bw / 2 - 4, py - bh / 2 - 4, bw + 8, bh + 8); c.setLineDash([]);
        if (S.sel === i) { c.fillStyle = '#ffffff'; c.strokeStyle = '#2e2e2d';
        c.beginPath(); c.arc(px + bw / 2 + 4, py + bh / 2 + 4, 7, 0, Math.PI * 2); c.fill(); c.stroke(); }
        c.restore();
      }
    }
  }
  // an empty name: a dashed box "Tap to add a name" at the name's spot (tap it to type the name)
  const holders = [];
  function drawPlaceholder(c, b, g, i) {
    let px = g.x + b.cx * g.w, py = g.y + b.cy * g.h;
    const vert = S.place[i].vertical;
    // the space it may use: the place's width (boxes never meet) and part of its height
    const room = (vert ? b.a.bottom - b.a.side : b.a.x1 - b.a.x0) * (vert ? g.h : g.w) * 0.88;
    const tall = (vert ? b.a.x1 - b.a.x0 : b.a.bottom - b.a.side) * (vert ? g.w : g.h) * 0.42;
    const n = size().people > 1 ? ` ${i + 1}` : '';
    const t = n ? `Tap to add name${n}` : 'Tap to add a name';
    c.save();
    // one row, always the same words, with a fixed size on the mat (about 3 cm letters, less on narrow places):
    // like the names, it just looks smaller when the view zooms out
    c.font = '600 13px system-ui, sans-serif';
    const per = c.measureText(t).width / 13 + 1.2; // box width per px of letter size (text + padding)
    const fs = Math.min(3 * g.k, room / per, tall / 2.35);
    // the box follows the words as drawn at this size (some browsers add the page's letter spacing)
    c.font = `600 ${fs}px system-ui, sans-serif`;
    let lines = [t], bw = c.measureText(t).width + fs * 1.2, bh = fs * 2.35;
    if (fs < 2.5) { bw = bh = Math.max(8, Math.min(26, room, tall)); lines = ['+']; } // a dot of a box: just a dashed "+"
    const fsDraw = lines[0] === '+' ? bw * 0.7 : fs;
    // keep the whole box inside the arch (names sit low in the arch)
    if (!vert) py = Math.min(py, g.y + b.a.bottom * g.h - bh / 2 - 3);
    c.translate(px, py); if (vert) c.rotate(-Math.PI / 2);
    c.fillStyle = 'rgba(255,255,255,.78)'; c.strokeStyle = S.sel === i ? '#c99a1c' : 'rgba(46,46,45,.55)';
    c.lineWidth = Math.max(1, Math.min(1.5, bw / 30)); c.setLineDash([Math.max(2, Math.min(5, bw / 8)), Math.max(2, Math.min(4, bw / 10))]);
    c.beginPath(); if (c.roundRect) c.roundRect(-bw / 2, -bh / 2, bw, bh, Math.min(8, bh / 3)); else c.rect(-bw / 2, -bh / 2, bw, bh);
    c.fill(); c.stroke(); c.setLineDash([]);
    c.fillStyle = '#2e2e2d'; c.textAlign = 'center'; c.textBaseline = 'middle'; c.font = `600 ${fsDraw}px system-ui, sans-serif`;
    c.fillText(lines[0], 0, fsDraw * 0.06);
    c.restore();
    // easy to tap even when it looks small (zoomed out): at least the place's width or 36 px
    const hw = Math.max(bw, Math.min(36, room / 0.88)), hh = Math.max(bh, Math.min(36, tall));
    holders[i] = { px, py, w: vert ? hh : hw, h: vert ? hw : hh };
  }


  // phone, Zoom in on a wide mat: a note at the bottom of the preview
  function drawSwipeNote(g) {
    // on the same line as See whole mat (bottom left), right of it, in the strip under the mat
    const t = isPhone() ? '←  Swipe to see every place  →' : '←  Drag the mat or use the arrows to see every place  →';
    const vb = $('.mp-view'), left = vb && !vb.hidden ? vb.offsetLeft + vb.offsetWidth + 8 : 8;
    const bh = 26, avail = W - left - 8;
    ctx.save(); let fs = 12; ctx.font = `600 ${fs}px system-ui, sans-serif`;
    while (fs > 9 && ctx.measureText(t).width + 22 > avail) { fs -= 0.5; ctx.font = `600 ${fs}px system-ui, sans-serif`; }
    const tw = ctx.measureText(t).width, bw = Math.min(avail, tw + 22), x = left + (avail - bw) / 2;
    const y = vb && !vb.hidden ? vb.offsetTop + (vb.offsetHeight - bh) / 2 : H - bh - 10;
    ctx.fillStyle = 'rgba(46,46,45,.82)'; ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x, y, bw, bh, 13); else ctx.rect(x, y, bw, bh); ctx.fill();
    ctx.fillStyle = '#fff'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(t, x + bw / 2, y + bh / 2 + 0.5, bw - 12);
    ctx.restore();
  }
  function drawDims(c, g, u = 1) { // u: label scale (export images are larger than the screen)
    const z = size(), [mw, mh] = z.matCm || z.cm, [iw, ih] = z.inch, n = z.parts ? z.parts.length : 1;
    c.save(); c.font = `600 ${12 * u}px system-ui, sans-serif`; c.fillStyle = '#616160'; c.textAlign = 'center';
    const fr = edgeCm() * g.k;
    c.strokeStyle = 'rgba(255,255,255,.85)'; c.lineWidth = 3 * u; c.lineJoin = 'round';
    const tx = (t, x0, y0) => { c.strokeText(t, x0, y0); c.fillText(t, x0, y0); };
    tx(`${n > 1 ? `${n} mats, each ` : ''}${iw}″ · ${mw} cm`, g.pan != null ? W / 2 : g.x + g.w / 2, Math.max(14 * u, g.y - fr - 8 * u));
    const p0 = z.parts ? z.parts[0] : { y0: 0, y1: 1 };
    c.translate(Math.max(14 * u, g.x - 12 * u), g.y + ((p0.y0 + p0.y1) / 2) * g.h); c.rotate(-Math.PI / 2);
    tx(`${ih}″ · ${mh} cm`, 0, 0);
    c.restore();
  }
  // store: nothing is drawn until the product's own design has loaded (no flash of another design, no wasted pictures)
  let designReady = !HOST;
  function render() {
    if (!designReady) { ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.fillStyle = '#ece7df'; ctx.fillRect(0, 0, W, H); setBusy('load', true); return; }
    holders.length = 0; waiting = false;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px'; // a resize resets it
    needFont(font());
    let g = geom(), real = S.view === 'real';
    if (tour) {
      const a = tourAmount();
      if (a == null) { tour = null; tourButtons(false); } else {
        if (tour.kind !== 'pulse') { // blend the Zoom in place of the mat with Real size / the whole mat
          const r = geom(W, H, tour.kind), mix = (p) => g[p] + (r[p] - g[p]) * a;
          g = { k: mix('k'), x: mix('x'), y: mix('y'), w: mix('w'), h: mix('h') };
          if (tour.kind === 'real') { real = a > 0.5; tourButtons(a > 0.5); }
        } else { // the mat steps back about 12% around the middle of the preview, then comes back
          const f = 1 - 0.12 * a, sc = (v, c) => c + (v - c) * f;
          g = { ...g, k: g.k * f, x: sc(g.x, W / 2), y: sc(g.y, H / 2), w: g.w * f, h: g.h * f };
        }
        schedule();
      }
    }
    drawFloor(ctx, W, H, g, real); drawMat(ctx, g, { ui: true }); drawDims(ctx, g);
    if (g.pan != null) drawSwipeNote(g);
    setBusy('load', waiting);
    // store: keep the hidden order lines in step with what the customer sees (moves, resizes, turns)
    if (HOST) { clearTimeout(render.t); render.t = setTimeout(writeOutputs, 300); }
    // tell the customer when a name color was switched to stay readable
    const sw = [...Array(size().people).keys()].filter((i) => S.names[i].trim() && inkFor(nameBox(i)).swapped);
    const note = $('#mp-ink-note'), msg = sw.length ? `${ink().name.replace(/ \(.*/, '')} is hard to read there, so ${sw.length > 1 || size().people > 1 ? 'those names use' : 'the name uses'} a readable color instead.` : '';
    if (note && note.textContent !== msg) { note.textContent = msg; note.hidden = !msg; }
  }

  /* ---------------- INTERACTION ---------------- */
  const pointers = new Map(); let gesture = null;
  function local(e) { const r = cv.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
  function hit(p) {
    const g = geom(), z = size();
    for (let i = z.people - 1; i >= 0; i--) {
      const b = nameBox(i, g); if (!b.text) continue;
      const px = g.x + b.cx * g.w, py = g.y + b.cy * g.h, bw = b.bw * g.w, bh = b.bh * g.h;
      if (S.sel === i && Math.hypot(p.x - (px + bw / 2 + 4), p.y - (py + bh / 2 + 4)) < 14) return { i, handle: true, px, py };
      if (Math.abs(p.x - px) <= bw / 2 + 8 && Math.abs(p.y - py) <= bh / 2 + 8) return { i, handle: false, px, py };
    }
    for (let i = 0; i < z.people; i++) {
      const q = holders[i];
      if (q && !S.names[i].trim() && Math.abs(p.x - q.px) <= q.w / 2 + 6 && Math.abs(p.y - q.py) <= q.h / 2 + 6) return { i, holder: true };
    }
    return null;
  }
  cv.addEventListener('pointerdown', (e) => {
    if (tour) { tour = null; tourButtons(false); } // a touch stops the size animation
    stopPan();
    const p = local(e); pointers.set(e.pointerId, p);
    if (pointers.size === 2 && S.sel >= 0) {
      const [a, b] = [...pointers.values()];
      gesture = { mode: 'pinch', d0: Math.hypot(a.x - b.x, a.y - b.y), s0: S.place[S.sel].scale }; return;
    }
    const h = hit(p);
    if (h && h.holder) { S.sel = h.i; gesture = null; syncTools(); schedule(); editName(h.i); e.preventDefault(); return; }
    if (!h) {
      S.sel = -1; syncTools(); schedule();
      // phone: a wide mat is swiped sideways
      gesture = pannable() ? { mode: 'pan', x0: p.x, pan0: S.pan } : null;
      if (gesture) cv.setPointerCapture(e.pointerId);
      return;
    }
    const wasSel = S.sel === h.i;
    S.sel = h.i; cv.setPointerCapture(e.pointerId);
    const P = S.place[h.i];
    gesture = h.handle
      ? { mode: 'scale', i: h.i, c: { x: h.px, y: h.py }, d0: Math.hypot(p.x - h.px, p.y - h.py), s0: P.scale }
      : { mode: 'move', i: h.i, p0: p, dx0: P.dx, dy0: P.dy, wasSel };
    syncTools(); schedule(); e.preventDefault();
  });
  cv.addEventListener('pointermove', (e) => {
    if (!pointers.has(e.pointerId)) { cv.style.cursor = hit(local(e)) ? 'move' : pannable() ? 'grab' : 'default'; return; }
    const p = local(e); pointers.set(e.pointerId, p);
    if (!gesture) return;
    if (gesture.mode === 'pan') { S.pan = gesture.pan0 - (p.x - gesture.x0); geom(); syncTools(); schedule(); return; }
    const g = geom();
    if (gesture.mode === 'move' && Math.hypot(p.x - gesture.p0.x, p.y - gesture.p0.y) > 6) gesture.moved = true;
    if (gesture.mode === 'pinch' && pointers.size === 2) {
      const [a, b] = [...pointers.values()];
      S.place[S.sel].scale = gesture.s0 * Math.hypot(a.x - b.x, a.y - b.y) / gesture.d0; clampScale(S.sel);
    } else if (gesture.mode === 'move') {
      const P = S.place[gesture.i];
      P.dx = gesture.dx0 + (p.x - gesture.p0.x) / g.w; P.dy = gesture.dy0 + (p.y - gesture.p0.y) / g.h;
      settle(gesture.i);
      // snap to the middle lines when close
      const gd = guideOf(gesture.i), b = nameBox(gesture.i, g);
      const offX = (gd.x - b.cx) * g.w, offY = (gd.y - b.cy) * g.h;
      gesture.snapX = Math.abs(offX) < SNAP; gesture.snapY = Math.abs(offY) < SNAP;
      if (gesture.snapX) P.dx += offX / g.w;
      if (gesture.snapY) P.dy += offY / g.h;
      if (gesture.snapX || gesture.snapY) {
        settle(gesture.i);
        const b2 = nameBox(gesture.i, g); // an area edge may stop it short of the line
        gesture.snapX = gesture.snapX && Math.abs((gd.x - b2.cx) * g.w) < 1; gesture.snapY = gesture.snapY && Math.abs((gd.y - b2.cy) * g.h) < 1;
      }
    } else if (gesture.mode === 'scale') {
      S.place[gesture.i].scale = gesture.s0 * Math.hypot(p.x - gesture.c.x, p.y - gesture.c.y) / Math.max(4, gesture.d0); clampScale(gesture.i);
    }
    schedule();
  });
  const end = (e) => {
    // phone: tapping a name that is already selected opens the typing box on the mat
    if (e.type === 'pointerup' && gesture && gesture.mode === 'move' && gesture.wasSel && !gesture.moved && isPhone()) editName(gesture.i);
    pointers.delete(e.pointerId); if (pointers.size < 2 && gesture && gesture.mode === 'pinch') gesture = null; if (!pointers.size) gesture = null; schedule(); };
  cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
  cv.addEventListener('wheel', (e) => {
    // trackpad / shift+wheel sideways on a wide mat: slide it
    const dx = e.deltaX || (e.shiftKey ? e.deltaY : 0);
    if (pannable() && Math.abs(dx) > Math.abs(e.shiftKey ? 0 : e.deltaY)) { e.preventDefault(); stopPan(); S.pan += dx; geom(); syncTools(); schedule(); return; }
    if (S.sel < 0) return; e.preventDefault();
    S.place[S.sel].scale *= e.deltaY < 0 ? 1.06 : 0.94; clampScale(S.sel); schedule();
  }, { passive: false });
  document.addEventListener('keydown', (e) => {
    if (S.sel < 0 || /input|textarea/i.test(document.activeElement.tagName)) return;
    const st = 0.005, P = S.place[S.sel], m = { ArrowLeft: [-st, 0], ArrowRight: [st, 0], ArrowUp: [0, -st], ArrowDown: [0, st] }[e.key];
    if (!m) return; e.preventDefault(); P.dx += m[0]; P.dy += m[1]; settle(S.sel); schedule();
  });

  /* ---------------- TYPING A NAME FROM THE PREVIEW ---------------- */
  // the page's own name field for person i (store), or the demo's
  function nameField(i) {
    if (!HOST) return $(`[data-name="${i}"]`);
    return size().people > 1 ? document.querySelector(`input[name="properties[Name ${i + 1}]"]:not([type="hidden"])`)
      : document.querySelector('input[name="properties[Personalization]"]:not([disabled]):not([type="hidden"])');
  }
  // computer: jump to the name field; phone: type right on the mat (the page's field is filled too)
  function editName(i) {
    const f = nameField(i); if (!f) return;
    if (isPhone()) { openInline(i, f); return; }
    const closed = f.closest('.oa-body[hidden]'); // option rows (accordion): open the Personalization row first
    if (closed && closed.previousElementSibling) closed.previousElementSibling.click();
    f.scrollIntoView({ block: 'center', behavior: 'smooth' }); f.focus({ preventScroll: true });
  }
  function openInline(i, f) {
    const wrap = cv.parentElement; let inp = $('#mp-inline');
    if (!inp) {
      inp = document.createElement('input'); inp.id = 'mp-inline'; inp.type = 'text'; inp.autocomplete = 'off'; inp.enterKeyHint = 'done';
      wrap.appendChild(inp);
      inp.addEventListener('input', () => { const t = inp._field; if (!t) return; t.value = inp.value; t.dispatchEvent(new Event('input', { bubbles: true })); });
      inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } });
      inp.addEventListener('blur', () => { inp.hidden = true; const t = inp._field; if (t) t.dispatchEvent(new Event('change', { bubbles: true })); });
    }
    ensureVisible(i);
    const g = geom(), b = nameBox(i, g);
    inp._field = f; inp.value = f.value; inp.placeholder = size().people > 1 ? `Name ${i + 1}` : 'Your name';
    if (f.maxLength > 0) inp.maxLength = f.maxLength;
    inp.style.top = `${Math.max(8, Math.min(H - 52, g.y + b.cy * g.h - 22))}px`;
    inp.hidden = false; inp.focus();
  }
  // wide mat (Zoom in): slide softly so person i is in the middle of the view
  function ensureVisible(i) {
    if (!pannable()) return;
    const g = geom(), b = nameBox(i, g);
    panTo(panGoal() + (g.x + b.cx * g.w) - W / 2);
  }
  // soft sideways slide of a wide mat (to a name, or with the arrows); a touch, drag or wheel stops it
  let panAnim = 0, panTarget = 0;
  const panGoal = () => (panAnim ? panTarget : S.pan);
  function panTo(target) {
    const g = geom(); if (g.pan == null) return;
    target = Math.max(0, Math.min(g.pan, target));
    stopPan();
    if (Math.abs(target - S.pan) < 1) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { S.pan = target; syncTools(); schedule(); return; }
    const from = S.pan, t0 = performance.now(), dur = Math.min(700, 280 + Math.abs(target - from) * 0.5);
    panTarget = target;
    const step = (now) => {
      const k = Math.min(1, (now - t0) / dur), e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; // ease in-out
      S.pan = from + (target - from) * e; render();
      if (k < 1) panAnim = requestAnimationFrame(step); else { panAnim = 0; syncTools(); }
    };
    panAnim = requestAnimationFrame(step);
  }
  function stopPan() { if (panAnim) { cancelAnimationFrame(panAnim); panAnim = 0; } }

  /* ---------------- CONTROLS ---------------- */
  function buildControls() {
    if (!HOST) {
      $('#mp-colors').innerHTML = CFG.colors.map((c) =>
        `<button type="button" class="mp-sw" data-color="${c.code}" aria-label="${c.name}" title="${c.name}"><i style="--c:${c.swatch}"></i></button>`).join('');
      buildSizes(); buildFonts();
    }
    buildInks();
    document.addEventListener('click', (e) => {
      if (HOST && !e.target.closest('.mm-lp')) return; // on the store: only the preview's own buttons
      const t = e.target.closest('[data-color],[data-size],[data-font],[data-ink],[data-act],[data-view],[data-design],[data-pan]'); if (!t) return;
      if (t.dataset.design) { loadDesign(t.dataset.design); return; }
      if (t.dataset.color) S.color = t.dataset.color;
      if (t.dataset.size) { S.size = t.dataset.size; S.sel = -1; if (S.view === 'whole') S.view = 'fit'; buildNames(); resize(); }
      if (t.dataset.font) {
        const was = !!font().inks; S.font = +t.dataset.font;
        if (was && !font().inks && CFG.defaultInk) S.ink = CFG.defaultInk;
        buildInks(); for (let i = 0; i < size().people; i++) clampScale(i);
      }
      if (t.dataset.ink) { S.ink = t.dataset.ink; if (HOST) writeOutputs(); }
      // store: one button that switches a wide mat between Zoom in (slides sideways) and the whole mat
      if (t.dataset.view) { S.view = t.dataset.view === 'toggle' ? (S.view === 'whole' ? 'fit' : 'whole') : t.dataset.view; resize(); syncTools(); schedule(); }
      if (t.dataset.pan) {
        const z = size(), places = z.parts ? z.parts.length : z.people, g = geom();
        panTo(panGoal() + (t.dataset.pan === 'next' ? 1 : -1) * (g.w / places)); return;
      }
      if (t.dataset.act) {
        const before = S.sel >= 0 ? S.place[S.sel].scale : 0;
        act(t.dataset.act);
        const same = S.sel >= 0 && S.place[S.sel].scale === before; // already at the smallest / biggest size
        if (HOST && S.sel >= 0) tip({ smaller: same ? 'Smallest size' : 'Smaller', bigger: same ? 'Biggest size that fits' : 'Bigger', default: 'Back to the default spot',
          rotate: S.place[S.sel].vertical ? 'Turned vertical' : 'Turned horizontal',
          link: S.linked ? 'Names move together' : 'Names move one by one' }[t.dataset.act]);
      }
      sync(); schedule();
    });
  }
  // name colors: "Match border" first (not for kids), then the design's list
  // a font can limit the name colors (kids Font A: white letters on the balls)
  const inkList = () => (font().inks ? font().inks.map((k) => DEFAULT_INKS.find((i) => i.key === k)).filter(Boolean) : CFG.inks);
  // name colors too close to the mat's own color (hard to read, or the same) are not offered
  function matBg() { return perMat(color().bg, 0) || color().swatch; }
  function readableInks() {
    const list = inkList(); if (CFG.fontInks || !matBg()) return list;
    const ok = list.filter((i) => contrast(i.hex, matBg()) >= 1.8);
    return ok.length ? ok : list;
  }
  var inksFor = '';
  function buildInks() {
    if (!$('#mp-inks')) return;
    inksFor = `${CFG.design}|${S.color}|${S.font}`;
    const canMatch = CFG.matchInk !== false && !font().inks;
    if (!(S.ink === 'match' && canMatch) && !readableInks().some((i) => i.key === S.ink)) S.ink = canMatch ? 'match' : readableInks()[0].key;
    $('#mp-inks').innerHTML = (CFG.matchInk !== false && !font().inks ? `<button type="button" class="mp-sw mp-sw-match" data-ink="match" aria-label="Match border" title="Match border"><i id="mp-match-sw"></i></button>` : '') + readableInks().map((i) =>
      `<button type="button" class="mp-sw" data-ink="${i.key}" aria-label="${i.name}" title="${i.name}"><i style="--c:${i.hex}"></i></button>`).join('');
  }
  function buildSizes() {
    if (HOST) return;
    $('#mp-sizes').innerHTML = CFG.sizes.map((z) =>
      `<button type="button" class="mp-size" data-size="${z.key}"><b>${z.label}</b><span>${z.sub}</span></button>`).join('');
  }
  function buildFonts() {
    if (HOST) return;
    $('#mp-fonts').innerHTML = CFG.fonts.map((f) =>
      `<button type="button" class="mp-font" data-font="${f.n}">${f.balls
        // kids Font A: the sample shows the letters on colored balls too
        ? `<span class="mp-balls" style="font-family:'${f.family}'">${[...'Aisha'].map((ch, k) => { const [l, m, d] = BALLS[k % BALLS.length]; return `<b style="--l:${l};--m:${m};--d:${d}">${ch}</b>`; }).join('')}</span>`
        : `<span style="font-family:'${f.family}';font-weight:${f.weight || 400}">Aisha</span>`}<small>${fontLabel(f)}</small></button>`).join('');
  }
  function buildNames() {
    if (HOST) { readPage(); return; }
    const z = size(), max = maxChars();
    $('#mp-names').innerHTML = Array.from({ length: z.people }, (_, i) => `
      <label class="mp-name">${z.people > 1 ? `<span>Person ${i + 1}</span>` : ''}
        <input type="text" data-name="${i}" maxlength="${max}" value="${esc(S.names[i].slice(0, max))}" placeholder="${z.people > 1 ? 'Name' : 'Name, initials or a short message'}" autocomplete="off">
        <em data-count="${i}">${S.names[i].slice(0, max).length}/${max}</em></label>`).join('');
    for (let i = 0; i < z.people; i++) S.names[i] = S.names[i].slice(0, max);
    $$('[data-name]').forEach((inp) => inp.addEventListener('input', () => {
      const i = +inp.dataset.name; S.names[i] = inp.value; $(`[data-count="${i}"]`).textContent = `${inp.value.length}/${max}`;
      clampScale(i); schedule();
    }));
    $$('[data-name]').forEach((inp) => inp.addEventListener('focus', () => { S.sel = +inp.dataset.name; syncTools(); schedule(); }));
  }
  function act(a) {
    const i = S.sel;
    if (a === 'bigger' && i >= 0) { S.place[i].scale *= 1.1; clampScale(i); }
    if (a === 'smaller' && i >= 0) { S.place[i].scale *= 0.9; clampScale(i); }
    if (a === 'rotate' && i >= 0 && !CFG.horizontalOnly && !CFG.verticalOnly) { S.place[i].vertical = !S.place[i].vertical; S.place[i].dx = 0; S.place[i].dy = 0; S.place[i].scale = 1; clampScale(i); }
    if (a === 'center' && i >= 0) { S.place[i].dx = 0; S.place[i].dy = 0; settle(i); }
    // Default spot: back to the design's fixed spot, size and direction (all names when moving together)
    if (a === 'default' && i >= 0) {
      const all = linked() ? [...Array(size().people).keys()] : [i];
      all.forEach((j) => { Object.assign(S.place[j], { dx: 0, dy: 0, scale: 1, vertical: startVertical() }); });
      clampScale(i);
    }
    if (a === 'link') { S.linked = !S.linked; if (S.linked) { const k = i >= 0 ? i : 0; clampScale(k); } }
    if (a === 'reset') { resetPlace(); S.sel = -1; if (linked()) settle(0); }
    if (a === 'download') download();
    if (a === 'cart') addToCartDemo();
    syncTools();
  }
  function sync() {
    if (inksFor !== `${CFG.design}|${S.color}|${S.font}`) buildInks(); // a new mat color: offer only readable name colors
    $$('[data-color]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.color === S.color));
    $$('[data-design]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.design === CFG.design));
    $$('[data-size]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.size === S.size));
    $$('[data-font]').forEach((b) => b.setAttribute('aria-pressed', +b.dataset.font === S.font));
    $$('[data-ink]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.ink === S.ink));
    if ($('#mp-match-sw')) $('#mp-match-sw').style.setProperty('--c', perMat(color().nameColor, 0));
    $$('[data-view]:not([data-view="toggle"])').forEach((b) => b.setAttribute('aria-pressed', b.dataset.view === S.view));
    setText('#mp-color-name', color().name);
    if (HOST) syncBar();
    setText('#mp-ink-name', ink().name.replace(/\s*\(.*\)$/, '')); // "Match border" without the hex numbers
    setText('#mp-font-name', `${fontLabel()} · ${font().family}`);
    // load only the mat on screen (phones: no downloading every size up front)
    (size().parts || [{}]).forEach((pt) => img(S.color, size().key, pt.side));
  }
  // store page: a short note above the name buttons says what the tapped button did
  function tip(text) {
    const box = $('#mp-tools'); if (!box || !text) return;
    let el = $('.mp-tip', box);
    if (!el) { el = document.createElement('span'); el.className = 'mp-tip'; el.setAttribute('role', 'status'); box.appendChild(el); }
    el.textContent = text; el.classList.add('is-on');
    clearTimeout(tip.t); tip.t = setTimeout(() => el.classList.remove('is-on'), 1400);
  }
  function syncTools() {
    const on = S.sel >= 0 && S.sel < size().people;
    // computer (store): the tools always stand left of the preview, dimmed until a name is selected
    const rail = HOST && !isPhone(), tools = $('#mp-tools');
    tools.hidden = !on && !rail; tools.classList.toggle('is-off', !on);
    $$('button', tools).forEach((b) => { b.disabled = !on; });
    // phone: with no name selected, an up/down swipe on the preview scrolls the page
    if (isPhone()) cv.style.touchAction = on ? 'none' : 'pan-y';
    // store: the view button only for a wide mat (single and 2-person mats already fit the frame)
    const vb = $('[data-view="toggle"]');
    if (vb) { const w = wideMat(); vb.closest('.mp-view').hidden = !w; vb.textContent = S.view === 'whole' ? 'Zoom in' : 'See whole mat'; }
    const pan = pannable(), g0 = pan ? geom() : null;
    $$('[data-pan]').forEach((b) => { b.hidden = !pan || (b.dataset.pan === 'prev' ? S.pan <= 1 : S.pan >= g0.pan - 1); });
    const hint = $('.mp-hint');
    if (hint && HOST) hint.textContent = pannable() ? (isPhone() ? 'Swipe the mat sideways to see every place. Tap a name to move it.' : 'Drag the mat sideways or use the arrows to see every place. Click a name to move it.') : 'Tap a name to move it, pinch or use the buttons to resize.';
    if (on) $('#mp-tools-label').textContent = linked() ? 'All names' : size().people > 1 ? `Person ${S.sel + 1}` : 'Name';
    // Turn button says which way the name will turn
    // (store page: icon buttons inside the preview, the words go in the tooltip)
    if (on) {
      const tb = $('#mp-turn'), word = S.place[S.sel].vertical ? 'Horizontal' : 'Vertical', icon = S.place[S.sel].vertical ? '↔' : '↕';
      if (!HOST) tb.textContent = `${icon} ${word}`; else if ($('span', tb)) $('span', tb).textContent = word; // store page: icon + which way it turns
      tb.title = `Turn ${word.toLowerCase()}`; tb.setAttribute('aria-label', tb.title);
    }
    $('#mp-turn').hidden = !!(CFG.horizontalOnly || CFG.verticalOnly); // some designs only take one direction (608: horizontal)
    const lb = $('#mp-link'); lb.hidden = size().people < 2;
    lb.setAttribute('aria-pressed', S.linked); if (!HOST) lb.textContent = S.linked ? '🔗 Moving together' : 'Move together';
    lb.title = S.linked ? 'Moving together (tap to move one by one)' : 'Move together'; lb.setAttribute('aria-label', lb.title);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m])); }

  /* ---------------- EXPORT + CART DATA ---------------- */
  // Export on the same floor as "Real size": every size at one cm scale, so in the cart a single mat
  // looks as small next to a 5-person mat as it really is.
  function exportCanvas(longSide = 1400) {
    const [fw, fh] = CFG.floorCm, c = document.createElement('canvas');
    c.width = longSide; c.height = Math.round(longSide * fh / fw);
    const x = c.getContext('2d');
    const g = geom(c.width, c.height, 'real'); drawFloor(x, c.width, c.height, g, true);
    drawMat(x, g, { scale: g.k / 4 }); drawDims(x, g, longSide / 700);
    return c;
  }
  function download() {
    exportCanvas().toBlob((b) => {
      const a = document.createElement('a'); a.href = URL.createObjectURL(b);
      a.download = `muslumana-${CFG.design}-${S.color}-${S.size}.png`; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    }, 'image/png');
  }
  // patch size in cm and color, for the design team (null when the design has no patch)
  function patchCm(b, pt) {
    if (!CFG.patch) return undefined;
    const st = barStyle(b);
    if (st) return { bar: b.vertical ? 'top to bottom of the arch' : 'from frame to frame', cm: +barThick({ ...b, emPx: b.em }, { k: 1, w: size().cm[0], h: size().cm[1] }).toFixed(1), fill: st.fill, line: st.line,
      lines: st.lines.map(([o, w]) => `${w} cm line ${o} cm in from the edge`).join(' and ') };
    if (CFG.patch === 'bar') return undefined;
    const z = size(), color = groundOf(img(S.color, z.key, pt && pt.side)); if (!color) return undefined;
    const q = patchBox({ ...b, emPx: b.em }, { k: 1, w: z.cm[0], h: z.cm[1] });
    if (CFG.patch === 'strip' && b.zone === b.a.area) return { strip: q.vert ? 'top to bottom of the arch' : 'from frame to frame', cm: +(q.vert ? q.w : q.h).toFixed(1), color };
    return { cm: [+(q.w + q.blur).toFixed(1), +(q.h + q.blur).toFixed(1)], color };
  }
  function designData() {
    const z = size();
    return {
      v: 1, design: CFG.design, color: S.color, size: z.key, mat_cm: z.matCm || z.cm, mats: z.parts ? z.parts.map((p) => p.side) : undefined,
      font: { n: S.font, family: font().family }, ink: { name: ink().name, hex: ink().hex },
      names: Array.from({ length: z.people }, (_, i) => {
        const b = nameBox(i); if (!b.text) return null;
        // x, y: center of the name as a fraction of the print image; letter_cm: letter size on the mat
        // couple sets: x is a fraction of that mat's own image (mat: left / right)
        const pt = z.parts && z.parts[b.a.part || 0], x = pt ? (b.cx - pt.x0) / (pt.x1 - pt.x0) : b.cx, y = pt ? (b.cy - pt.y0) / (pt.y1 - pt.y0) : b.cy;
        // for the design team: the same in cm on the mat, the font size in pt, and the size of the text box
        const [mw, mh] = z.matCm || z.cm, V = S.place[i].vertical;
        return { person: i + 1, mat: pt ? pt.side : undefined, text: b.text, x: +x.toFixed(4), y: +y.toFixed(4), rotate: V ? -90 : 0, letter_cm: +b.em.toFixed(2), color: inkFor(b).hex,
          font_pt: Math.round((b.em / 2.54) * 72), x_cm: +(x * mw).toFixed(1), y_cm: +(y * mh).toFixed(1), box_cm: [+((V ? b.th : b.tw)).toFixed(1), +((V ? b.tw : b.th)).toFixed(1)],
          patch: patchCm(b, pt) };
      }).filter(Boolean),
    };
  }
  function properties() {
    const z = size(), p = { 'Color': color().name, 'Size': `${z.label} (${z.sub})`, 'Font': fontLabel(), 'Name color': ink().name };
    for (let i = 0; i < z.people; i++) if (S.names[i].trim()) p[z.people > 1 ? `Name ${i + 1}` : 'Name'] = S.names[i].trim();
    p['Preview'] = '(image link, saved when added to cart)';
    // staff only: one readable line per name, so the design team can rebuild the design in its own print file
    const d = designData(), [mw, mh] = z.matCm || z.cm;
    d.names.forEach((n) => {
      p[`_Print ${z.people > 1 ? n.person : ''}`.trim()] = `"${n.text}" · ${fontLabel()} (${font().family}) · font size ${n.font_pt} pt (${n.letter_cm} cm) · color ${n.color.toUpperCase()} · `
        + `${n.rotate ? 'vertical, reads bottom to top' : 'horizontal'} · center ${n.x_cm} cm from left, ${n.y_cm} cm from top${n.mat ? ` of the ${n.mat} mat` : ''} (mat ${mw}×${mh} cm) · text box ${n.box_cm[0]}×${n.box_cm[1]} cm`
        + (n.patch && n.patch.bar ? ` · solid bar ${n.patch.cm} cm ${n.rotate ? 'wide' : 'tall'} ${n.patch.bar} in ${n.patch.fill.toUpperCase()}, border lines in ${n.patch.line.toUpperCase()} on both edges (${n.patch.lines})` : '')
        + (n.patch && !n.patch.bar ? (n.patch.strip ? ` · clear the pattern in a ${n.patch.cm} cm ${n.rotate ? 'wide' : 'tall'} strip ${n.patch.strip}, soft edges, in ${n.patch.color.toUpperCase()}`
          : ` · clear the pattern behind the name: soft patch ${n.patch.cm[0]}×${n.patch.cm[1]} cm in ${n.patch.color.toUpperCase()}`) : '');
    });
    p['_Design'] = JSON.stringify(d);
    p['_Model Code'] = `${CFG.design}${S.color}`;
    return p;
  }
  function addToCartDemo() {
    const url = exportCanvas(900).toDataURL('image/png');
    const p = properties();
    $('#mp-cart').hidden = false;
    $('#mp-cart-img').src = url;
    $('#mp-cart-props').innerHTML = Object.entries(p).map(([k, v]) =>
      `<div class="${k.startsWith('_') ? 'mp-hidden-prop' : ''}"><b>${esc(k)}</b><span>${esc(v)}</span></div>`).join('');
    $('#mp-cart').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ---------------- START ---------------- */
  // standard sizes and fonts (designs can bring their own in design.json)
  const DEFAULT_SIZES = CFG.sizes.map((z) => ({ ...z })), DEFAULT_FONTS = CFG.fonts, DEFAULT_INKS = CFG.inks;
  // Couple sets: cm, inch and positions in design.json are per mat; here the mats are put side by side
  // (gapCm apart) and every position becomes a fraction of the whole set, like a single mat.
  function prepSize(z) {
    // single mats with their own sizes (kids): an arch with spans (419) gets its exact inside shape as the name area
    const area = (sp) => ({ spans: sp, x0: Math.min(...sp.map((q) => q[1])), x1: Math.max(...sp.map((q) => q[2])), y0: sp[0][0], y1: sp[sp.length - 1][0] });
    if (!z.mats) return { ...z, arches: z.arches.map((a) => (a.spans ? { ...a, area: area(a.spans) } : a)) };
    const n = z.mats.length, gap = z.gapCm || 0, [mw, mh] = z.cm, T = n * mw + (n - 1) * gap;
    const off = z.offsetCm || z.mats.map(() => 0), TH = mh + Math.max(...off); // offsetCm: a mat sits lower (709: hearts line up)
    const parts = z.mats.map((side, k) => ({ side, x0: (k * (mw + gap)) / T, x1: (k * (mw + gap) + mw) / T, y0: off[k] / TH, y1: (off[k] + mh) / TH }));
    const X = (r, part) => {
      const p = parts[part], fx = (v) => p.x0 + v * (p.x1 - p.x0), fy = (v) => p.y0 + v * (p.y1 - p.y0), o = { ...r };
      ['x0', 'x1'].forEach((k) => { if (r[k] != null) o[k] = fx(r[k]); });
      ['y0', 'y1', 'top', 'side', 'bottom'].forEach((k) => { if (r[k] != null) o[k] = fy(r[k]); });
      if (r.spans) { // exact shape: convert every row, and keep its outer box for the "same spot in the heart" logic
        o.spans = r.spans.map(([y, l, rr]) => [fy(y), fx(l), fx(rr)]);
        Object.assign(o, { x0: Math.min(...o.spans.map((q) => q[1])), x1: Math.max(...o.spans.map((q) => q[2])), y0: o.spans[0][0], y1: o.spans[o.spans.length - 1][0] });
      }
      return o;
    };
    const arches = z.arches.map((a) => { const o = X({ ...a, spans: undefined }, a.part || 0); if (a.spans) o.area = X({ spans: a.spans }, a.part || 0); if (a.edge) o.edge = X({ spans: a.edge }, a.part || 0).spans; return o; });
    const zones = z.zones && z.zones.map((list, i) => list.map((r) => X(r, arches[i].part || 0)));
    return { ...z, cm: [T, TH], matCm: [mw, mh], parts, arches, zones };
  }
  buildControls(); buildNames(); sync(); syncTools();
  // Load a design: designs/<code>/design.json holds its colors, the arch positions per size and the default name spot.
  function loadDesign(code) {
    const url = HOST ? HOST.designUrl : `designs/${code}/design.json`;
    const get = () => fetch(url).then((r) => (r.ok ? r.json() : null));
    // one more try after a short wait if the connection drops
    const wait = (ms) => new Promise((ok) => setTimeout(ok, ms));
    return get().catch(() => wait(1200).then(get)).catch(() => wait(3000).then(get)).then((j) => {
      if (!j || !Array.isArray(j.colors) || !j.colors.length) return;
      CFG.design = code; CFG.designName = j.name || code; CFG.imgBase = HOST ? HOST.filesBase : `designs/${code}/`; designReady = true;
      CFG.colors = j.colors.map((c) => ({ code: c.code, name: c.name, swatch: c.swatch, nameColor: c.nameColor || '#1d1d1f' }));
      CFG.colors.forEach((c, k) => { c.bg = j.colors[k].bg; c.fill = j.colors[k].fill; c.v = j.colors[k].v; });
      CFG.imgV = j.imgV || '';
      // a color letter picked before this design arrived (from the built-in list, e.g. H = Dark Green) may not exist here (706: only A)
      if (!CFG.colors.some((c) => c.code === S.color)) S.color = CFG.colors[0].code;
      if (j.nameDefault) CFG.nameDefault = j.nameDefault;
      CFG.minLetterCm = j.minLetterCm || 4; // a design may need bigger letters (101, 102: 5 cm, for the velvet/embroidery)
      // sizes: the design's own list (kids, couple sets) or the standard sizes with this design's arches
      // an arch with spans (608) gets its exact inside shape as the name area
      const withArea = (list) => list.map((a) => (a.spans ? { ...a, area: { spans: a.spans, x0: Math.min(...a.spans.map((q) => q[1])), x1: Math.max(...a.spans.map((q) => q[2])), y0: a.spans[0][0], y1: a.spans[a.spans.length - 1][0] } } : a));
      CFG.sizes = j.sizes ? j.sizes.map(prepSize) : DEFAULT_SIZES.map((z) => ({ ...z, arches: withArea((j.arches && j.arches[z.file]) || z.arches), zones: (j.zones && j.zones[z.file]) || null }));
      CFG.tile = j.tile || null; CFG.horizontalOnly = !!j.horizontalOnly; CFG.verticalOnly = !j.horizontalOnly && !!j.verticalOnly;
      CFG.nameStyle = j.nameStyle || null; CFG.patch = (j.nameStyle && j.nameStyle.patch) || false; // true = patch around the name, 'strip' = from frame to frame
      CFG.fonts = j.fonts || DEFAULT_FONTS;
      // name colors: keys from the standard list, or the design's own colors ({ key, name, hex })
      CFG.inks = j.inks ? j.inks.map((k) => (typeof k === 'object' ? k : DEFAULT_INKS.find((i) => i.key === k))).filter(Boolean) : DEFAULT_INKS;
      CFG.photoFringeCm = j.photoFringeCm || 0;
      CFG.drawFringe = j.fringe !== false; CFG.drawBinding = j.binding !== false; // photo-based mats (101) bring their own edges
      CFG.textureOn = j.texture !== false && j.fringe !== false; // and already show the real fabric: no texture on them
      CFG.matchInk = j.matchInk !== false; CFG.textShadow = !!j.textShadow; CFG.fontInks = !!j.fontInks;
      S.ink = CFG.defaultInk = j.defaultInk || 'match';
      if (!CFG.sizes.some((z) => z.key === S.size)) S.size = CFG.sizes[0].key;
      if (!CFG.fonts.some((f) => f.n === S.font)) S.font = 1;
      buildInks();
      S.linked = j.linked !== false;
      buildSizes(); buildFonts(); buildNames();
      fontAsked.clear(); needFont(font()); allFontsLater();
      if (!CFG.colors.some((c) => c.code === S.color)) S.color = CFG.colors[0].code;
      if ($('#mp-colors')) $('#mp-colors').innerHTML = CFG.colors.map((c) =>
        `<button type="button" class="mp-sw" data-color="${c.code}" aria-label="${c.name}" title="${c.name}"><i style="--c:${c.swatch}"></i></button>`).join('');
      setText('.mp-eyebrow', `${code} · ${CFG.designName}`);
      resetPlace(); S.sel = -1; if (linked() && size().parts) settle(0); // couple sets: both names start on the same spot of their mat
      if (HOST) { readPage(true); hostReady(); }
      for (let i = 0; i < size().people; i++) clampScale(i);
      sync(); syncTools(); resize();
    }).catch((e) => { if (window.console) console.warn("live preview:", e); });
  }
  /* ---------------- THEME MODE: the store's product page ---------------- */
  // Reads the page's own choices (variant, names, font) and writes the staff-only order lines.

  function readPage(first) {
    if (!HOST) return;
    const sec = HOST.section, form = document.getElementById(`product-form-${sec}`);
    const prod = HOST.product, vid = form && form.querySelector('input[name="id"]') && +form.querySelector('input[name="id"]').value;
    const v = prod.variants.find((x) => x.id === vid) || prod.variants.find((x) => x.available) || prod.variants[0];
    const opt = (name) => { const k = prod.options.findIndex((o) => (o.name || o).toLowerCase() === name); return k >= 0 ? v.options[k] : ''; };
    // color letter: from the store's Model Code map (variant id -> "i-light-blue-801"), else by color name
    let code = null;
    try { const mc = JSON.parse((document.getElementById(`ModelCodes-${sec}`) || {}).textContent || '{}'); if (mc[v.id]) code = String(mc[v.id]).split('-')[0].toUpperCase(); } catch (_) {}
    if (!code || !CFG.colors.some((c) => c.code === code)) { const n = opt('color').toLowerCase(); const c = CFG.colors.find((x) => x.name.toLowerCase() === n); if (c) code = c.code; }
    if (code && CFG.colors.some((c) => c.code === code)) S.color = code;
    // size: 26"x45" -> 26x45
    const file = (opt('size').match(/(\d+)\D+(\d+)/) || []).slice(1, 3).join('x');
    const z = CFG.sizes.find((q) => q.file === file);
    const sizeChanged = z && z.key !== S.size, oldSize = S.size;
    if (z) S.size = z.key;
    if (sizeChanged && S.view === 'whole') S.view = 'fit'; // a new size starts zoomed in
    if (sizeChanged && linked() && size().parts) settle(S.sel >= 0 ? S.sel : 0); // couple sets: names keep the same spot on both mats
    // font: "Clover (Font 1)" -> 1, kids "Font B" -> 2
    const fr = document.querySelector(`input[name="properties[Font]"]:checked`);
    const fm = fr && fr.value.match(/Font\s*([0-9]+|[A-Z])\b/i);
    if (fm) { const n = /\d/.test(fm[1]) ? +fm[1] : fm[1].toUpperCase().charCodeAt(0) - 64; if (CFG.fonts.some((f) => f.n === n)) S.font = n; }
    // 101, 102: the Font buttons are the name color (Black / Silver / Gold, one script)
    if (CFG.fontInks && font().ink) S.ink = font().ink;
    // names: one field, or Name 1…5 for family sizes
    const one = document.querySelector('input[name="properties[Personalization]"]:not([disabled])');
    const people = size().people;
    for (let i = 0; i < 5; i++) {
      const el = people > 1 ? document.querySelector(`input[name="properties[Name ${i + 1}]"]`) : (i === 0 ? one : null);
      S.names[i] = el ? el.value : '';
    }
    if (sizeChanged && !first) { S.sel = -1; S.pan = 0; resize(); sizeTour(oldSize); }
    hostVariant = v.id;
  }
  // order lines: the chosen name color and the preview picture's link (_Preview). The print details (_Print …, _Design)
  // are not sent any more: they crowded the order page and emails; the preview picture shows the placement.
  function writeOutputs() {
    if (!HOST) return;
    const box = document.getElementById('mm-lp-out'); if (!box) return;
    const formId = `product-form-${HOST.section}`, any = S.names.slice(0, size().people).some((n) => n.trim());
    const wanted = {};
    if (any) {
      if (!CFG.fontInks) wanted['Name color'] = `${ink().name.replace(/\s*\(.*\)$/, '')} (${String(ink().hex).toUpperCase()})`; // e.g. "Navy (#1F2A44)": the cart shows a swatch of it
      // the saved preview picture, only while it still shows exactly this design
      if (shot.url && shot.key === shotKey() && mode !== 'forme') wanted._Preview = shot.url;
    }
    if (mode === 'forme') wanted.Design = 'Design it for me - email me a proof to approve';
    $$('input', box).forEach((inp) => { if (!(inp.dataset.key in wanted)) inp.remove(); });
    Object.entries(wanted).forEach(([k, val]) => {
      let inp = box.querySelector(`input[data-key="${CSS.escape(k)}"]`);
      if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.dataset.key = k; inp.name = `properties[${k}]`; inp.setAttribute('form', formId); box.appendChild(inp); }
      inp.value = val;
    });
  }
  /* ---------------- LOADING / SAVING SPINNER ON THE PREVIEW ---------------- */
  const busy = { load: false, save: false };
  function setBusy(kind, on) {
    if (busy[kind] === !!on) return;
    busy[kind] = !!on;
    const wrap = cv.parentElement; let el = $('.mp-busy', wrap);
    if (!el) { el = document.createElement('div'); el.className = 'mp-busy'; el.setAttribute('role', 'status'); el.innerHTML = '<i></i><span></span>'; wrap.appendChild(el); }
    el.classList.toggle('is-on', busy.load || busy.save);
    el.classList.toggle('is-saving', busy.save);
    $('span', el).textContent = busy.save ? 'Saving your design…' : '';
  }

  /* ---------------- PREVIEW PICTURE FOR THE ORDER (Cloudflare Worker → Shopify Files) ---------------- */
  // The mat with the names, as the customer made it: saved when they add to cart, its link goes on the order as _Preview.
  const shot = { key: '', url: '', busy: null };
  function shotKey() { try { return JSON.stringify(designData()); } catch (_) { return String(Math.random()); } }
  // Square picture (1:1): the mat fills 80% of it, centered, with its size line at the bottom.
  function previewCanvas(side = 1400) {
    const z = size(), [mw, mh] = z.cm, fr = edgeCm(), c = document.createElement('canvas');
    c.width = c.height = side;
    // every mat fills 80% of the square on its longer side (height for single mats, width for family mats), centered
    const k = side * 0.8 / Math.max(mw, mh + 2 * fr);
    const g = { k, x: (side - mw * k) / 2, y: side * 0.465 - (mh * k) / 2, w: mw * k, h: mh * k };
    const x = c.getContext('2d');
    drawFloor(x, side, side, g, false); drawMat(x, g, { scale: k / 4 });
    // size line: 26″ × 45″ · 66 × 113 cm (couple sets: per mat)
    const [cw, ch] = z.matCm || z.cm, n = z.parts ? z.parts.length : 1;
    const famOrder = z.people > 1 && !z.parts; // family sizes are written depth × length (45″ × 95″), so are their cm
    const t = `${n > 1 ? `${n} mats, each ` : ''}${String(z.label || '').replace('×', ' × ')} · ${famOrder ? `${ch} × ${cw}` : `${cw} × ${ch}`} cm`;
    x.save(); x.font = `600 ${Math.round(side * 0.026)}px system-ui, sans-serif`; x.textAlign = 'center'; x.textBaseline = 'middle';
    const tw = x.measureText(t).width, ph = side * 0.05, pw = tw + side * 0.05, py = side * 0.93;
    x.fillStyle = 'rgba(255,255,255,.88)'; x.beginPath();
    if (x.roundRect) x.roundRect(side / 2 - pw / 2, py - ph / 2, pw, ph, ph / 2); else x.rect(side / 2 - pw / 2, py - ph / 2, pw, ph);
    x.fill(); x.fillStyle = '#2e2e2d'; x.fillText(t, side / 2, py + 1); x.restore();
    return c;
  }

  function uploadPreview() {
    if (!HOST || !HOST.previewApi) return Promise.resolve('');
    const key = shotKey();
    if (shot.url && shot.key === key) return Promise.resolve(shot.url);
    if (shot.busy && shot.busy.key === key) return shot.busy.p;
    const z = size(), q = new URLSearchParams({ design: CFG.design, color: S.color, size: z.key });
    const p = new Promise((ok) => previewCanvas().toBlob(ok, 'image/jpeg', 0.86))
      .then((blob) => fetch(`${HOST.previewApi.replace(/\/$/, '')}/upload?${q}`, { method: 'POST', headers: { 'Content-Type': 'image/jpeg' }, body: blob }))
      .then((r) => r.json().catch(() => ({})).then((j) => { if (!r.ok) console.warn('[live preview] picture not saved:', r.status, j.error || ''); return j; }))
      .then((j) => { if (j.url) { shot.key = key; shot.url = j.url; writeOutputs(); console.info('[live preview] picture saved:', j.url); } return j.url || ''; })
      .catch((e) => { console.warn('[live preview] picture not saved:', e && e.message); return ''; })
      .finally(() => { if (shot.busy && shot.busy.p === p) shot.busy = null; });
    shot.busy = { key, p };
    return p;
  }
  const hasNames = () => S.names.slice(0, size().people).some((n) => n.trim());

  // The preview sits inside the photo gallery, above the thumbnails, in the exact box of the big photo.
  // (function declarations: they can run during start-up, e.g. when the page opens on a family size via ?variant=)
  function gallery() { const st = document.querySelector('.mm-lp-stage'); return st && st.closest('media-gallery'); }
  function viewer(g) { return g && g.querySelector('[id^="GalleryViewer-"]'); }
  function hostBox() {
    const g = gallery(), v = viewer(g), wrapper = g && g.closest('.product__media-wrapper'), cw = cv.parentElement;
    if (!v || !wrapper) return false;
    // measure the photo shown now (the viewer is hidden while the preview shows: show it for a moment, no paint happens)
    const on = wrapper.classList.contains('mm-lp-show-preview');
    if (on) wrapper.classList.remove('mm-lp-show-preview');
    const c = v.querySelector('.product__media-item.is-active .product-media-container') || v.querySelector('.product-media-container');
    const r = c && c.getBoundingClientRect(), gr = g.getBoundingClientRect();
    if (on) wrapper.classList.add('mm-lp-show-preview');
    if (!gr.width) return false;
    if (isPhone()) { // phone: the full width and a taller preview; the controls go under it
      W = Math.round(gr.width);
      const z = size(), [mw, mh] = z.cm, fr = edgeCm();
      if (S.view === 'real') H = Math.round(W * 0.8);
      else if (z.people > 1 || z.parts) H = Math.round(Math.max(W * 0.75, Math.min(W * 1.3, (mh + 2 * fr) * phoneZoom(W, 1e6) + 104)));
      // not the window height: on iPhone it changes while scrolling (address bar), which made the mat grow and shrink
      else H = Math.round(Math.min(W * 1.45, ((window.screen && screen.height) || 800) * 0.6));
      g.style.setProperty('--mm-lp-right', '0px'); g.style.setProperty('--mm-lp-left', '0px');
      cw.style.width = `${W}px`; cw.style.height = `${H}px`; cw.style.marginLeft = '0px';
      cv.style.height = H + 'px';
      if (cv.width !== Math.round(W * dpr) || cv.height !== Math.round(H * dpr)) { cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); }
      placeControls(); syncTools(); schedule();
      return true;
    }
    placeControls();
    // a photo box that is missing or not laid out yet: use a square the width of the gallery
    const ok = r && r.width > gr.width * 0.5 && r.height > 120;
    const box = ok ? r : { left: gr.left, width: gr.width, height: gr.width / (parseFloat(c && c.style.getPropertyValue('--ratio')) || 1) };
    const left = Math.max(0, Math.min(box.left - gr.left, gr.width - box.width));
    g.style.setProperty('--mm-lp-right', `${Math.max(0, gr.width - left - box.width)}px`); g.style.setProperty('--mm-lp-left', `${left}px`); // the thumbnails line up with the photo
    // always a square, like the photos: a tall video or photo open in the gallery never stretches the preview
    W = Math.round(box.width); H = W;
    cw.style.width = `${W}px`; cw.style.height = `${H}px`; cw.style.marginLeft = `${left}px`;
    // the name tools stand in a column outside the preview, on its left (the preview keeps its full size);
    // with no room at all there, they sit just inside its left edge
    // room left of the preview: full column (icons + words), else a slim one (icons only, the word shows on hover/tap)
    const room = gr.left + left, full = room >= RAIL + 4, slim = !full && room >= SLIM, tl = $('#mp-tools');
    if (tl) tl.classList.toggle('is-slim', slim);
    cw.parentElement.style.setProperty('--mp-rail-left', `${full ? left - RAIL : slim ? left - SLIM : left + 8}px`); cw.parentElement.style.setProperty('--mp-rail-h', `${H}px`);
    cv.style.height = H + 'px';
    if (cv.width !== Math.round(W * dpr) || cv.height !== Math.round(H * dpr)) { cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); }
    syncTools(); schedule();
    return true;
  }
  // phone: the name buttons go right under the preview (not over the mat);
  // See whole mat / Zoom in stays on the preview, bottom left, on phones and computers
  function placeControls() {
    const wrap = cv.parentElement, under = $('#mp-under-phone'), tools = $('#mp-tools'), view = $('.mp-view');
    if (!under || !tools || !view) return;
    const toolsHome = isPhone() ? under : wrap.parentElement; // computer: the column left of the preview
    if (tools.parentElement !== toolsHome) toolsHome.appendChild(tools);
    if (view.parentElement !== wrap) wrap.appendChild(view);
  }
  // phone bar: Size, Color, Font and Name color, changed right from the preview (they use the page's own buttons)
  function optionInputs(name) {
    const re = new RegExp(`^\\s*${name}`, 'i');
    for (const fs of document.querySelectorAll('variant-selects fieldset')) {
      const lg = fs.querySelector('legend');
      if ((fs.dataset.optionName && re.test(fs.dataset.optionName)) || (lg && re.test(lg.textContent))) return [...fs.querySelectorAll('input[type="radio"]')];
    }
    return [];
  }
  function prettySize(v) { return v.replace(/"/g, '″').replace(/\s*x\s*/i, '×'); }
  function fillSheet(kind) {
    const sheet = $('#mp-sheet'); if (!sheet) return;
    let html = '';
    if (kind === 'size') html = optionInputs('size').map((inp) => `<button type="button" class="mp-pick mp-pick-size" data-pick="${inp.id}" aria-pressed="${inp.checked}">${esc(prettySize(inp.value))}</button>`).join('');
    if (kind === 'color') html = optionInputs('colou?r').map((inp) => {
      const sw = document.querySelector(`label[for="${inp.id}"] .swatch`), st = sw ? sw.getAttribute('style') || '' : '';
      return `<button type="button" class="mp-pick mp-pick-color" data-pick="${inp.id}" aria-pressed="${inp.checked}"><i style="${esc(st)}"></i><span>${esc(inp.value)}</span></button>`;
    }).join('');
    if (kind === 'font') html = [...document.querySelectorAll('input[name="properties[Font]"]')].map((inp) => {
      const sm = document.querySelector(`label[for="${inp.id}"] .font-sample`), cap = (inp.value.match(/Font\s*\w+/) || [inp.value])[0];
      return `<button type="button" class="mp-pick mp-pick-font" data-pick="${inp.id}" aria-pressed="${inp.checked}">${sm ? sm.outerHTML : ''}<span>${esc(cap)}</span></button>`;
    }).join('');
    if (kind === 'ink') html = `<div class="mp-swatches">${$('#mp-inks') ? $('#mp-inks').innerHTML.replace(/ id="mp-match-sw"/, '') : ''}</div>`;
    sheet.innerHTML = html; sheet.dataset.kind = kind; sheet.hidden = !html;
    $$('[data-sheet]').forEach((b) => b.setAttribute('aria-expanded', b.dataset.sheet === kind && !!html));
    sync();
  }
  function closeSheet() { const sh = $('#mp-sheet'); if (sh) { sh.hidden = true; sh.dataset.kind = ''; } $$('[data-sheet]').forEach((b) => b.setAttribute('aria-expanded', 'false')); }
  function syncBar() {
    // each chip shows what is chosen, with a small picture: the mat's shape, its color, the name in the font, the ink
    const rich = (k, key, build) => { const el = $(`[data-sheet="${k}"] small`); if (!el || el.dataset.key === key) return; el.dataset.key = key; el.textContent = ''; build(el); };
    const add = (el, tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; el.appendChild(n); return n; };
    const chk = (list) => list.find((x) => x.checked);
    const sz = chk(optionInputs('size')), co = chk(optionInputs('colou?r')), fo = document.querySelector('input[name="properties[Font]"]:checked');
    const z = size(), [iw, ih] = z.matCm || z.cm, sizeText = sz ? prettySize(sz.value) : z.label;
    rich('size', `${sizeText}|${iw}x${ih}|${(z.parts || []).length}`, (el) => {
      add(el, 'span', '', sizeText);
    });
    const colorText = co ? co.value : color().name;
    rich('color', `${colorText}|${color().swatch}`, (el) => { add(el, 'i', 'mp-chip-sw').style.background = color().swatch; add(el, 'span', '', colorText); });
    const typed = (S.names || []).map((n) => n.trim()).find(Boolean), fontText = fo ? (fo.value.match(/Font\s*\w+/) || [fo.value])[0] : fontLabel();
    rich('font', `${typed || ''}|${S.font}|${fontText}`, (el) => {
      // the customer's own name (or the font's name) written in that font
      const t = add(el, 'span', 'mp-chip-font', font().balls ? fontText : (typed || fontText));
      if (!font().balls) t.style.font = `${font().weight || 400} 13px "${font().family}"`;
    });
    // Match border: the color's own name ("Charcoal"), one dot per mat on couple sets; other inks: their name
    const ik = ink(), match = ik.key === 'match', hexes = match ? [].concat(color().nameColor) : [ik.hex];
    const inkText = match ? [...new Set(hexes.map(hueName))].join(' / ') : ik.name.replace(/\s*\(.*\)$/, '');
    rich('ink', `${inkText}|${hexes.join(',')}`, (el) => { hexes.forEach((h) => { add(el, 'i', 'mp-chip-sw mp-chip-dot').style.background = h; }); add(el, 'span', '', inkText); });
    const sb = $('[data-sheet="size"]'); if (sb) sb.hidden = !optionInputs('size').length; // one size (101, 102) still shows, selected
    // 101/102: no separate name color; the Font button is "Font color"
    const ib = $('[data-sheet="ink"]'); if (ib) ib.hidden = !!CFG.fontInks;
    const fb = $('[data-sheet="font"] b'); if (fb) fb.textContent = CFG.fontInks ? 'Font color' : 'Font';
  }
  function showPreview(on) {
    const g = gallery(), wrapper = g && g.closest('.product__media-wrapper'); if (!wrapper) return;
    wrapper.classList.toggle('mm-lp-show-preview', on);
    if (on) resize();
  }
  function hostReady() {
    const st = document.querySelector('.mm-lp-stage'); if (!st) return;
    // move the preview into the gallery, right above the big photo (the thumbnails stay below it)
    const g = st.closest('.product__media-wrapper') && st.closest('.product__media-wrapper').querySelector('media-gallery'), v = viewer(g);
    if (v) v.before(st);
    st.hidden = false;
    const wrapper = st.closest('.product__media-wrapper'); if (wrapper) wrapper.classList.add('mm-lp-on');
    const inks = document.querySelector('.mm-lp-inks'); if (inks) inks.hidden = !!CFG.fontInks; // 101/102: the Font buttons choose the color
    // first visit: ask how they want to make the mat (over the preview)
    const cw = cv.parentElement;
    if (!$('.mp-ask', cw)) {
      const ask = document.createElement('div'); ask.className = 'mp-ask'; ask.hidden = !!mode;
      ask.innerHTML = '<div class="mp-ask-card" role="group" aria-label="How would you like to create your mat?"><b class="mp-ask-title">How would you like to create your mat?</b>'
        + `<button type="button" data-mode="self"><span aria-hidden="true">${PEN(22)}</span><b>Design it myself</b><small>Type the names and see them on your mat right away</small></button>`
        + `<button type="button" data-mode="forme"><span aria-hidden="true">${MAIL(22)}</span><b>Design it for me</b><small>Our team designs it and emails you a proof to approve before we make it</small></button></div>`;
      cw.appendChild(ask);
    }
    placeModeRow();
    setMode(mode, false);
  }
  // the "Design" row above the Color option: switch any time
  function placeModeRow() {
    if (document.querySelector('.mm-lp-mode')) return;
    const vs = document.querySelector(`#MainProduct-${HOST.section} variant-selects`) || document.querySelector('variant-selects');
    if (!vs) return;
    const block = vs.closest('.product__info-container > *') || vs;
    const row = document.createElement('div'); row.className = 'mm-lp mm-lp-mode';
    row.innerHTML = '<p class="mm-lp-label">Design</p><div class="mm-lp-mode-btns">'
      + `<button type="button" data-mode="self">${PEN(24)}Design it myself<small>see the live preview</small></button>`
      + `<button type="button" data-mode="forme">${MAIL(24)}Design it for me<small>we email you a proof</small></button></div>`
      + '<p class="mp-note mm-lp-mode-note" hidden>Please choose your color, size, font and name color, and type the names below: our designers use them to create your mat. We\'ll email you a proof to approve before we make it.</p>';
    block.before(row);
  }
  function setMode(m, byUser) {
    mode = m;
    if (byUser && m) { try { localStorage.setItem('mm-lp-mode', m); } catch (_) { /* private mode */ } }
    const ask = $('.mp-ask'); if (ask) ask.hidden = !!m;
    showPreview(m !== 'forme');
    $$('[data-mode]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mode === m)));
    const note = $('.mm-lp-mode-note'); if (note) note.hidden = m !== 'forme';
    writeOutputs();
  }
  if (HOST) {
    let t = 0;
    const update = () => { clearTimeout(t); t = setTimeout(() => { readPage(); for (let i = 0; i < size().people; i++) clampScale(i); sync(); syncTools(); schedule(); writeOutputs(); }, 80); };
    // "Design it myself": any change to the mat (size, color, names, font, name color) brings the live preview back over the photos
    const backToPreview = () => {
      const g = gallery(), w = g && g.closest('.product__media-wrapper');
      if (mode === 'self' && w && !w.classList.contains('mm-lp-show-preview')) showPreview(true);
    };
    document.addEventListener('input', (e) => { if (e.target.name && /^properties\[(Personalization|Name \d)\]$/.test(e.target.name)) { update(); backToPreview(); } });
    document.addEventListener('change', (e) => {
      update();
      const t = e.target;
      if (t && ((t.closest && t.closest('variant-selects')) || /^properties\[(Personalization|Name \d|Font)\]$/.test(t.name || ''))) backToPreview();
    });
    document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('.mm-lp-inks [data-ink]')) backToPreview(); });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.variantChange, update);
    // the order lines are written again right before Add to cart sends the form
    // Add to cart: first save the preview picture (at most ~8 s; the sale never waits longer or fails because of it)
    let passing = false;
    document.addEventListener('submit', (e) => {
      const form = e.target; if (!form.getAttribute || form.getAttribute('id') !== `product-form-${HOST.section}`) return; // (form.id is the variant input named "id")
      writeOutputs();
      if (passing || mode === 'forme' || !HOST.previewApi || !hasNames() || (shot.url && shot.key === shotKey())) return;
      e.preventDefault(); e.stopImmediatePropagation();
      const btn = form.querySelector('[type="submit"]'); if (btn) btn.classList.add('loading');
      setBusy('save', true);
      Promise.race([uploadPreview(), new Promise((ok) => setTimeout(ok, 8000))]).then(() => {
        writeOutputs(); if (btn) btn.classList.remove('loading'); setBusy('save', false);
        passing = true;
        try { if (form.requestSubmit) form.requestSubmit(btn && btn.form === form ? btn : undefined); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); } finally { passing = false; }
      });
    }, true);
    // start saving the picture as soon as a finger or the mouse goes down on Add to cart (often done before the click)
    document.addEventListener('pointerdown', (e) => {
      const b = e.target.closest('button[type="submit"], [name="add"]');
      if (b && (b.getAttribute('form') || (b.form && b.form.getAttribute('id'))) === `product-form-${HOST.section}` && hasNames() && mode !== 'forme') uploadPreview();
    }, true);
    // tapping a name field selects that name in the preview
    document.addEventListener('focusin', (e) => {
      const m = e.target.name && e.target.name.match(/^properties\[(?:Personalization|Name (\d))\]$/);
      if (m) { S.sel = m[1] ? +m[1] - 1 : 0; ensureVisible(S.sel); syncTools(); schedule(); }
    });
    // phone bar: open a list; picking from it uses the page's own button
    document.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-sheet]');
      if (chip) {
        const sh = $('#mp-sheet'); if (!sh) return;
        if (!sh.hidden && sh.dataset.kind === chip.dataset.sheet) closeSheet();
        else { sh.style.setProperty('--mp-sheet-top', `${chip.offsetTop}px`); fillSheet(chip.dataset.sheet); }
        return;
      }
      const pick = e.target.closest('[data-pick]');
      if (pick) { const inp = document.getElementById(pick.dataset.pick); if (inp && !inp.checked) inp.click(); closeSheet(); return; }
      if (e.target.closest('#mp-sheet [data-ink]')) { setTimeout(closeSheet, 0); return; }
      // computer: a click anywhere else closes the open list
      if (!isPhone() && !e.target.closest('#mp-sheet')) closeSheet();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSheet(); });
    // Design it myself / Design it for me (first-visit question, the row above Color, the button in the preview)
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-mode]'); if (!b || !b.closest('.mm-lp')) return;
      setMode(b.dataset.mode, true);
      if (b.dataset.mode === 'self' && b.closest('.mm-lp-mode')) { const st = document.querySelector('.mm-lp-stage'); if (st && st.getBoundingClientRect().bottom < 0) st.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
    // the theme rebuilds the options after a change: put the Design row back if it went
    new MutationObserver(() => { if (!document.querySelector('.mm-lp-mode')) { placeModeRow(); setMode(mode, false); } })
      .observe(document.getElementById(`MainProduct-${HOST.section}`) || document.body, { childList: true, subtree: true });
    // "Show photos" / "Show live preview" buttons; tapping a thumbnail shows that photo
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-mm-lp-tab]');
      if (b) { if (b.dataset.mmLpTab === 'preview' && mode === 'forme') setMode('self', true); else showPreview(b.dataset.mmLpTab === 'preview'); return; }
      const g = gallery();
      if (g && e.target.closest('[id^="GalleryThumbnails-"] button, [id^="GalleryThumbnails-"] .thumbnail') && g.contains(e.target)) showPreview(false);
    });
    // phone: once the preview has scrolled away, a "See your design" button brings it back
    const back = document.createElement('button');
    back.type = 'button'; back.className = 'mm-lp-back'; back.tabIndex = -1;
    back.innerHTML = '<span aria-hidden="true">✎</span> See your design';
    document.body.appendChild(back);
    back.addEventListener('click', () => {
      const st = document.querySelector('.mm-lp-stage'); if (!st) return;
      if (mode !== 'forme') showPreview(true);
      const hd = document.querySelector('sticky-header, .shopify-section-header-sticky'), hh = hd ? Math.max(0, hd.getBoundingClientRect().height) : 0;
      const smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      window.scrollTo({ top: window.scrollY + st.getBoundingClientRect().top - hh - 8, behavior: smooth ? 'smooth' : 'auto' });
    });
    let backQ = 0;
    const backCheck = () => {
      backQ = 0;
      const st = document.querySelector('.mm-lp-stage'), g = gallery(), sec = document.getElementById(`MainProduct-${HOST.section}`);
      const r = (g || st) && (g || st).getBoundingClientRect(), sr = sec && sec.getBoundingClientRect();
      // only below the preview and still on the product (not down in the reviews or the footer)
      const on = isPhone() && mode !== 'forme' && !!r && !st.hidden && r.bottom < 40 && (!sr || sr.bottom > window.innerHeight * 0.6);
      if (back.classList.contains('is-on') !== on) { back.classList.toggle('is-on', on); back.tabIndex = on ? 0 : -1; }
    };
    window.addEventListener('scroll', () => { if (!backQ) backQ = requestAnimationFrame(backCheck); }, { passive: true });
    // phones: only a new width matters (scrolling on iPhone changes the height all the time)
    let lastW = window.innerWidth;
    window.addEventListener('resize', () => {
      if (isPhone() && window.innerWidth === lastW) return;
      lastW = window.innerWidth; if (gallery()) resize();
    });
  } else {
    $('#mp-designs').innerHTML = CFG.designs.map((d) => `<button type="button" class="mp-size" data-design="${d.code}"><b>${d.code}</b><span>${d.name}</span></button>`).join('');
  }
  loadDesign(HOST ? HOST.design : CFG.design);
  // re-fit when the space gets wider or narrower (a taller stage, e.g. an opened list, is not a reason)
  let roW = -1;
  new ResizeObserver((en) => { const w = Math.round(en[0].contentRect.width); if (w === roW) return; roW = w; resize(); })
    .observe(HOST ? (document.querySelector('.mm-lp-stage') || cv.parentElement) : cv.parentElement);
  resize();
  window.MP = { S, CFG, designData, properties, schedule, clampScale, buildNames, sync, readPage, writeOutputs, size, holders, nameBox, zonesFor, inkFor };
})();